var _path, _path2, _g, _g2, _path3, _path4, _path5, _g3, _g4, _path6, _g5, _g6, _path7, _g7, _g8, _g9, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1064 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0f47af",
    d: "M0 0h1064v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 200h1064v200H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.13)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.01 353.35c1.52 0 3.17 0 10.11-1.7 6.94-1.64 12.67-5.85 14.02-6.46 1.34-.6 3.3-.43 3.3-.43-.75-.78-2.87-2.74-5.87-2.74-3.03 0-1.82 0-4.38 1.09-2.56 1.04-7.9 4.3-16.92 4.3h-.17c-9.03 0-14.67-3.26-17.23-4.3-2.56-1.09-1.39-1.09-4.38-1.09-3.04 0-5.12 1.96-5.9 2.74 0 0 2-.17 3.34.43 1.35.61 7.07 4.82 14.02 6.47 6.9 1.69 8.59 1.69 10.06 1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.37 347.44c.74-.43-.17-1.65-.17-1.65l2.73-.6c-1.35-.61-3.34-.44-3.34-.44-.52.43-.43.96-.52 1.34-.05.4-.05 1 .26 1.3.26.27 1.04.05 1.04.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.92 345.19l-2.73.6s.9 1.22.17 1.66l4.82-.91s-.74-.53-2.26-1.35zM541.69 347.44c-.74-.43.13-1.65.13-1.65l-2.69-.6c1.35-.61 3.3-.44 3.3-.44.56.43.47.96.56 1.34.04.4.04 1-.26 1.3-.3.27-1.04.05-1.04.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.13 345.19l2.69.6s-.87 1.22-.13 1.66l-4.82-.91s.74-.53 2.26-1.35z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M495.84 343.31l-1.22 3.03.57.22c.9.4 1.81.19 2.25-.81.39-1.04-.14-1.81-1-2.16l-.6-.28zm.25.63l.1.03c.69.3 1.11.8.8 1.62-.34.78-1.03.8-1.68.5l-.12-.03.9-2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M497.22 347.48l1.34-2.98.35.13-1.35 2.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.21 345.28c-.63.02-1.24.44-1.53 1.1-.39.86-.01 1.79.81 2.18.83.35 1.8-.03 2.2-.94a1.74 1.74 0 0 0-.85-2.22 1.5 1.5 0 0 0-.63-.12zm-.03.5c.15 0 .32.03.47.1.65.25.82.95.56 1.56-.26.6-.96.91-1.53.65-.52-.26-.8-.9-.5-1.56.2-.46.56-.75 1-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M503.81 347.36c-.04-.22-.13-.39-.35-.48-.21-.08-.56 0-.65.26-.08.26.09.48.22.61l.22.17c.34.3.56.66.34 1.18-.21.56-.78.78-1.3.6-.43-.17-.7-.69-.56-1.21l.39.09c-.13.3.04.65.34.78.3.13.66-.1.79-.4.13-.34-.09-.56-.3-.78l-.18-.17c-.26-.26-.48-.56-.3-1 .17-.47.7-.65 1.12-.47.35.13.53.39.57.73l-.35.09zM506.2 347.53l-.52 1.82c-.13.52-.13 1.04.43 1.22.61.17.87-.26 1.04-.78l.52-1.87.35.13-.56 1.95c-.18.7-.74 1.13-1.43.92-.7-.18-.96-.83-.74-1.52l.56-2 .35.13zM510.58 352.04l-1.82-2.99-.48 2.38-.35-.04.65-3.38 1.78 2.95.48-2.34.35.04zM511.4 351.96l.4-3.22.34.05-.39 3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.18 348.88a1.63 1.63 0 0 0-1.68 1.6c-.05 1 .65 1.73 1.56 1.77.87.05 1.64-.62 1.69-1.62.04-.91-.7-1.75-1.57-1.75zm-.06.47c.7.04 1.14.63 1.1 1.28 0 .7-.56 1.16-1.16 1.16-.61-.05-1.1-.6-1.1-1.25.05-.65.51-1.2 1.16-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M519.08 352.14l-2.51-2.35.17 2.43h-.4l-.25-3.38 2.52 2.33-.18-2.38.4-.05zM521.12 351.65l-.6-3.2.39-.05.56 2.82.91-.17.09.38zM522.86 351.3l-.74-3.17.4-.08.73 3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.87 347.72c-.13 0-.26.03-.4.06l-.35.13.88 3.12.69-.15c.52-.18.95-.57.78-1.22-.09-.35-.42-.64-.82-.6.18-.17.2-.5.16-.72-.16-.52-.53-.64-.94-.62zm.07.4c.2-.03.4.06.5.38.13.4-.14.5-.44.6l-.1.03-.3-.94h.12a.94.94 0 0 1 .22-.06zm.5 1.32c.25-.03.52.02.59.34.13.4-.17.57-.47.66l-.28.1-.25-1 .19-.04c.07-.02.13-.05.22-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M527.24 347.97l.13.34-1.17.4.39 1.16 1.21-.43.13.39-1.56.53-1.08-3.08 1.6-.57.09.34-1.21.43.3.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.62 346.19c-.3-.04-.55.03-.8.16l-.45.18 1.22 3.03.35-.12-.47-1.31.12-.03 1.35.9.46-.15-1.46-.97c.39-.22.51-.7.34-1.13a.87.87 0 0 0-.66-.56zm-.1.4c.18.02.33.13.42.35.17.43-.19.65-.54.78l-.06.03-.4-1 .09-.03c.15-.06.33-.14.5-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M529.24 345.76l1.7-.75.16.31-.7.3 1.23 2.65-.36.17-1.2-2.64-.66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.21 344.19l.22 3.72.4-.22-.05-.84 1.28-.66.68.56.35-.22-2.88-2.34zm.44.88l1 .8-.9.48-.1-1.28zM535.31 342.88c-.32.02-.66.12-.97.31l-.56.31 1.72 2.82.5-.28c.87-.52 1.25-1.4.69-2.35-.35-.6-.85-.84-1.38-.81zm.16.5c.3.03.6.2.84.56.44.74.03 1.3-.62 1.69l-.06.03-1.2-1.94.1-.09c.33-.17.64-.28.94-.25z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    stroke: "#000",
    strokeMiterlimit: 2.61
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 0.13,
    fill: "#e60000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.07 355.17c.52 0 .91-.4.91-.91a.88.88 0 0 0-.91-.87c-.48 0-.91.39-.91.87 0 .52.43.91.91.91zM479.95 361.5c.52 0 .91-.39.91-.91a.92.92 0 0 0-.91-.91.95.95 0 0 0-.91.9c0 .53.43.92.91.92zM468.06 341.63c.48 0 .91-.43.91-.91a.92.92 0 0 0-.91-.91c-.52 0-.91.39-.91.9 0 .49.39.92.91.92zM460.68 345.32c.52 0 1-.43 1-1 0-.52-.48-1-1-1a1 1 0 0 0-1 1c0 .57.44 1 1 1zM459.34 323.02a1 1 0 0 0 1-1c0-.52-.48-1-1-1a1 1 0 0 0-1 1c0 .57.44 1 1 1zM453.13 324.84c.56 0 1-.43 1-1 0-.56-.44-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zM456.3 304.97a1 1 0 0 0 1-1c0-.56-.44-1-1-1s-1 .44-1 1a1 1 0 0 0 1 1zM450.75 286.7c.52 0 1-.43 1-.95a1 1 0 0 0-1-1c-.56 0-1 .43-1 1 0 .52.44.95 1 .95zM457.82 288.52c.56 0 1-.43 1-1 0-.52-.44-1-1-1a1 1 0 0 0-1 1c0 .57.44 1 1 1zM464.76 273.3a1 1 0 0 0 1-1c0-.52-.48-.95-1-.95-.56 0-1 .43-1 .95 0 .57.44 1 1 1zM459.47 269.09c.56 0 1-.43 1-1a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .57.44 1 1 1zM470.01 258.85c.56 0 1-.43 1-1s-.44-1-1-1-1 .44-1 1c0 .57.44 1 1 1zM448.49 305.1c.56 0 1-.43 1-.95a.97.97 0 0 0-1-.96.96.96 0 0 0-.95.96c0 .52.43.95.95.95z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.26,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.93 358.9s-.74-3.17-.6-3.9l.77-.61M484.72 360.11s-2.82.13-3.73.43c0 0 0 .18-.3.79M467.28 345.8s-.17-3.77.6-4.08c0 0 .75-.3 1.18-.91M464.41 344.58s-2.13-.3-2.73 0c0 0-.13.6-.61.78M460.34 322.45l-.74.43c-.78.3-2.25 3.95-2.25 3.95s-2.43-1.82-3.47-2h-1.09M447.97 304.66s.6.6 1.21.3c0 0 3 1.96 3.17 2.74 0 0 3.17-3.17 3.78-2.87 0 0 .3.44.9-.17M451.31 286.14s.3.43.87.74c0 0 1.39 2 1.39 3.47 0 0 2.56-2.26 3.3-2.08 0 0 .9.3 1.51 0M458.69 268.83s.6.74 1.04.13c0 0 1.82 2.26.74 3.95 0 0 2.56-.6 3.34-.17 0 0 .3 1.04 1.21.43"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 0.26,
    fill: "#1f601a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.79 378.34s-3.9-.3-4.51-.3c-.61 0-1.96-2.7-2.56-3.17-.61-.43-10.85-5.42-17.49-6.46-6.64-1.05-16.83-5-18.96-6.04-11.02-5.29-23.34-15.1-26.08-19.13-2.86-4.2-5.9-14.02-7.24-19.26-.61-2.44-3.9-12.37-3.9-19.14 0-7.85.9-14.32 2.12-19.44 1.17-5.12 9.98-20.13 15.36-26.81 0 0-12.1 18.74-14.19 25.9-2.08 7.38-2.69 16.36-2.56 21.48.13 4.2 3.64 19.61 8.76 30.93 4.08 9.07 7.64 10.16 14.02 15.23a90.9 90.9 0 0 0 13.54 8.6c4.81 2.38 15.05 5.42 17.79 5.85 2.69.48 16.4 4.51 18.22 5.43 1.82.9 6.47 4.99 7.68 6.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.11 343.41c.3-1.39.43-2.43.91-2.86.43-.48 1.95-2.3 2.26-3.47.3-1.22 0-2.13 0-2.74 0-.6.43-2.69.43-2.69s-.74-2.56-1.35-3.04c-.6-.43-2.12-2.56-2.42-3.16 0 0 .17 1.21-.3 1.82-.44.6-.62 2.13-.62 3 0 .9.3 3.03 0 4.07-.3 1.17-.73 2.13-.43 3.47.26 1.09 1.52 5.6 1.52 5.6zM463.63 341.89s-3.43-4.38-3.43-6.2c0-1.78-.3-2.87-.6-3.3-.3-.44-2.26-2.74-.48-5.56.78-1.21.91-1.12 1.34-2.43.61-1.64 1.83-1.64 2-3.3 0 0 .43 1.96.56 3.6.18 1.66-.13 2.27-.26 3.18-.17.9.44 1.95.44 3.3 0 1.38-.18 1.9-.18 2.73 0 .43-.56 6.16.61 7.98zM502.25 365.41s-2.9-.3-4-.48c-.77-.08-2.55-.52-3.55-.9a11.3 11.3 0 0 1-4.03-2.79c-2.78-2.95-2.52-4.5-3-4.64-1-.17 1.56-.43 2.78-.26 1.17.13 2.82 1 3.9 2.04 1.13 1.04 2.87 2.21 3.47 2.65.61.47 1.05.65 1.7 1.52.65.86.6 1.43 2.73 2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.24 367.53s-7.29-3.25-8.03-3.86c-.78-.57-2-1.74-2.77-2.56-.74-.83-3.82-2.39-4.34-3.39-.35-.7-2.26-3.34-3.39-5.42-.56-1.08 4.86.35 4.86.35 4.43 1.78 2.43.52 4.86 2.34 1.48 1.13 2.48 2.08 2.87 2.9.56 1.31 1.21 3.57 1.86 4.74.6 1.17 1.78 2.69 4.08 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.19 368.45s-6.03-1.56-8.76-5.3c-1.96-2.55-1.96-1.77-2.78-2.64-1-1.09-2.56-2.26-3.86-4.47.13.22-1.74-5.9-1.65-6.64.04-.43 2.3.3 4.12 1.09 1.56.65 2.47 1.9 3.82 2.73 1.6 1.04 1.82 3.64 2.56 4.86 1.04 1.78 1.17 2.7 1.17 3.56-.04 1.34.74 1.78 1.17 2.9.52 1.35 2.13 1.13 4.21 3.91zM500.56 366.45s-5.12-2.26-5.86-2.43c-.78-.13-1.08-.6-2.12-.91-.87-.22-1.65-.87-3.78-.43-.91.21-4.64 1.04-5.55.6-.91-.48 1.34 2.56 2.38 3.17 1.09.6 2.87.91 4.39.74 1.51-.13 3.6 0 4.38 0 .74 0 1.17.17 2.25-.13 1.05-.3 1.35-.78 3.91-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.03 366.45s-5.73-1.43-6.68-1.43c-.96 0-3.69.17-4.82.39-1.08.17-4.51-.17-5.5.35-1.05.47-5.6 1.12-6.82.82-1.22-.26 2.43 3.25 3.86 3.64 4.64 1.3 3.25 1.13 6.25.35 1.82-.48 4.43-.6 5.34-.74.9-.17.73-.7 1.95-1.21 1.21-.52 3.25-1.82 6.42-2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.71 368.84s-5.73-2.39-10.2-1.17c-3.08.87-3 .74-4.2.95-1.44.22-2.65-.52-5 .44-1.17.47-6.16 2.51-7.54 2.43-1.26-.09 3.99 3.34 5.42 3.12 4.6-.65 8.94.91 11.06.04 1.91-.73 3.04-1.25 4-1.56.95-.35 1.47-1.21 2.08-1.65.6-.47 1-1.65 4.38-2.6zM478.13 355.69s-3.3-3.64-3.95-4.12c-.6-.48-2.17-1.6-3-2.35-.69-.6-1.38-1.95-3.5-2.47-.92-.22-3.13-.65-3.78-1.43-.6-.83.13 2.9.82 3.9a8.1 8.1 0 0 0 3.6 2.56c1.44.52 3.26 1.57 3.9 1.91.7.3 1.05.65 2.14.83 1.08.22 1.56-.09 3.77 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.25 357.21s-5.6-3.95-6.47-4.38a46.3 46.3 0 0 0-3.5-1.3c-1.1-.3-3.91-2.35-5.04-2.35s-3.26-.08-4.21-.82c-1-.78-.13 2.73.95 3.73 3.6 3.2 1.13 2.26 4.12 2.86 1.83.4 4.26 1.4 5.12 1.65.92.26 1-.3 2.3-.21 1.3.04 3.74-.22 6.73.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.59 358.25s-2.3-1.52-6.85-2.3c-3.13-.57-3-.7-4.17-1-1.39-.43-1.7-.43-4.25-.56-1.26-.09-6.2 1.52-7.38.82-1.08-.6 1.22 1.52 2.6 2.04 2 .74 1.74 2.04 3.91 2.73 2.3.74 4.73 1.65 6.07 1.4 1.05-.22 1.83-.7 3.3-.83 1.43-.18 3.95-2.26 6.77-2.3zM483.07 357.08s1.13-5.47.17-6.77a5.2 5.2 0 0 1-1.21-2.86 10.92 10.92 0 0 0-1.65-4.34c-.6-.78-1.82-4.25-1.52-5.12 0 0-3.17 3.12-3 5.12.14 1.95.14 1.48 0 2.39-.17.9.74 3.9 1.35 4.81.6.91.3 3.65.91 4.21.61.6 4.21 3.04 4.95 2.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.59 358.25c.35.17-1.9-1.74-3-2.21-1.04-.44-5.24-1.65-5.55-2.7-.3-1.08-3.77-4.68-3.9-5.6-.13-.69-.78-2.12-.61-2.86.13-.73.43-2.56.91-3.6.43-1.08 1.48-3.6 2.56-4.07 0 0 .87 2.86 1.17 3.9.3 1.09.6 2.3 1.09 2.86.43.61 1.95 3.47 2.08 4.56.17 1.04.91 4.51 1.08 5.25.13.74 2.96 3.82 4.17 4.47zM464.11 343.41c.13.78-2.26-.78-3.47-.78s-4.82.48-5.73-.43c-.9-.92-2.25-2.56-2.73-2.87-.44-.3-2.08-3.04-2.56-4.51-.44-1.52-3.6-4.25-4.04-4.56 0 0 4.34-.86 7.08.91 2.69 1.83 2.86 1.4 3.47 1.65.6.3 5.25 4.26 5.55 5.73.3 1.52 2.26 4.08 2.43 4.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.11 343.41s-3.9-2.73-4.82-2.6c-.9.17-5.16-3-5.42-4.95-.17-1.04-2.21-2.52-2.56-3.17-1.08-1.82-1.7-5.85-3.17-6.94 0 0 4.08 1.04 5.12 1.22 1.96.3 3.6.6 4.34 2.25.78 1.65 1.4 3.04 2 3.17.6.17 1.47 2.26 1.78 4.38.3 2.08 2.73 6.64 2.73 6.64zM456.73 322.89c.65 1.04.6-6.03.87-6.77.3-.74 1.08-2.26 1.69-2.86.6-.61.6-2.7.91-3.3.26-.6.13-4.69-.3-5.73 0 0-1.22.91-1.83 1.65-.6.74-1.64 1.04-1.95 1.95-.3.92-.9.92-1.34 1.83a5.57 5.57 0 0 0-.61 3.6c.3 1.21.13 1.65.13 2.73 0 1.04 1.52 5.55 2.43 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.86 323.49s-.3-1.95.48-2.69c.73-.78 1.47-.78 1.78-1.22.3-.47.17-1.04.47-1.64.3-.61.96-1.61 1.04-2.13.3-1.65 1.22-3.47.44-5.25 0 0-1.65.56-2.08.87-.48.3-1.83 1.52-1.96 2.73-.17 1.35-.3 1.52-.78 2.26-.43.74-1.04 3-.3 4.38a7.4 7.4 0 0 1 .91 2.69zM452.48 300.46s-.3-4.38.91-5.73c1.22-1.34 1.52-3.9 4.21-5.3 0 0-.13 1.1 0 1.83.17.74.48 2.87 0 3.6-.43.78-1.95 2.13-1.95 2.74 0 .6-1.04 2.12-1.78 2.43-.78.26-1.39.43-1.39.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.48 302.84s0-3.12.91-4.03c.91-.92 1.39-1.4 1.82-1.96.44-.6.91-2.12 1.96-2.73 1.04-.6 2.86-2.13 3.03-2.7 0 0 .44 3.74-.6 5.74-1.09 1.95-1.09 3-2.26 3.42-1.21.48-1.39.79-1.82 1.09-.48.3-1.22.74-1.82.74-.61 0-1.22.43-1.22.43zM455.95 323.36c.17.87.78-1.95-2.39-1.95s-5.72-1.22-6.8-2.3c-1.05-1.04-1.66-1.78-2.1-2.26a8.94 8.94 0 0 1-1.81-3.17c-.13-.86-1.04-4.2-.91-4.81 0 0 1.69.3 2.43.9.73.62 2.12.62 2.86 1.1.74.43 1.34 1.64 1.82 2.08.44.47 1.78.47 2.39 1.34.6.91 1.65 2.87 1.82 3.78.13.9 1.22 1.82 1.95 2.25.74.48.61 2.26.74 3.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65 322.15s-2.08-2.56-3.17-2.56c-1.04 0-3.73-2.73-3.9-3.9-.13-1.22-1.04-3.48-1.65-3.95a3.63 3.63 0 0 1-1.52-3.3c.17-1.82.17-4.82.17-4.82s.61 1.83 1.48 2.26c.91.43 2.56 1.04 2.86 1.65.3.6 1.52.6 2 2.43.43 1.78.43 1.65.74 2.26.3.6 1.04 1.34 1.34 2.56.3 1.2 1.95 4.33 1.65 7.37zM452.53 305.53c-.09.82 1.21-1.6-1.65-2.47-2.9-.87-4.9-2.7-5.55-3.95-.65-1.22-1-2.08-1.3-2.6-.26-.57-.87-2.52-.74-3.39.09-.87.22-4.12.52-4.64 0 0 1.43.74 1.9 1.47.53.78 1.79 1.17 2.35 1.78.52.6.74 1.87 1.04 2.43.3.52 1.52.91 1.83 1.87.3 1 .69 3.08.56 3.95-.09.86.6 1.95 1.17 2.6.56.6-.09 2.21-.13 2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.57 304.32s-1.21-2.9-2.17-3.17c-.95-.3-2.52-2.77-2.6-3.9-.13-1.3-.3-3.47-.74-4.04-.43-.56-1.21-2.43-.6-4.03.64-1.6 1.64-3.73 1.64-3.73s.87 1.34 1.35 2.17c.78 1.56 1.56 1.69 1.69 2.3.09.65 1.04 1.04 1.39 2.3.48 1.69-.04 1.6.04 2.25.13.6.6 1.52.52 2.7-.04 1.16.6 4.5-.52 7.15zM454.91 286.14c.13-.43 1.04-.91 2.13-1.21 1.04-.3 2.69-2.7 3.42-3.3.7-.65 1.09-1.6 2-2.13.9-.52 1.47-2.39 1.78-4.2 0 0-2.56.6-3.3.73a7.14 7.14 0 0 0-2.86 1.82c-.61.74-1.22 1.96-1.83 2.26-.6.3-1.34 2.12-1.34 3.34v2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.78 284.79s-.17-1.78-.17-2.56c0-.91-.57-3.34.73-5.3.92-1.34 4.26-3.9 5.12-4.03 0 0 .61 2.39.48 3.12-.17.79-.95 3.78-1.65 4.08-.7.3-2.43 3.9-4.51 4.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 286.14c-.39.65-.13-2.26-1.04-3-.91-.77-1.04-1.82-1.04-3.03 0-1.22.26-2.08.43-2.86.13-.74 2.43-3.91 2.26-4.82l1.65 3.77c.47 1.05-.3 2.13-.13 3 .13.9.86 2.56.3 3.47-.48.78-1.82 2.43-2.43 3.47zM461.98 270.61s.17-.43 1.52-.43 3.3-.13 3.9-.74c.61-.6 1.65-1.4 2.26-1.7a5.15 5.15 0 0 0 1.82-2.25c.13-.6 1.22-1.78 1.65-1.78 0 0-1.65-.17-3.47.3-1.78.44-4.34 1.35-4.95 2.56a49.55 49.55 0 0 1-2.73 4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.46 270.3c.35 1.04 2.86-1.04 3.43-1.78l1.52-1.95s1.43-1.74 1.82-2.43c.91-1.65.7-4.64.3-4.38-.47.3-2.12 1.21-2.56 1.39-.47.13-1.34.43-1.65 1.17-.3.78-.6 1.82-1.08 2.3-.43.43-3.17 1.95-1.78 5.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.55 270.3s2.08-1.48 2.86-2.26c.91-.86.44-2.08.91-2.69.4-.56 1.48-1.95 1.18-2.86-.3-.91-.87-3.47-.87-3.47s-1.09 1.04-1.82 1.82c-.78.74-.91 1.35-1.22 2.26-.3.9-.9 1.52-1.21 2.25-.3.74 0 2.26.17 3.17.13.91 0 1.78 0 1.78z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.13,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.83 365.23s-9.94-.13-10.85-1.35M500.56 366.45s-6.47 1.78-9.94 1.35c-3.47-.44-5.12.3-5.9.3-.73 0-4.51-1.52-4.51-1.52M507.19 368.84s-4.99.91-6.03 1.21c-1.04.3-6.16 2.26-7.68 2.26-1.22 0-4.17-.13-5 0-1.47.3-5.41 0-6.32-.43M488.37 356.95s3.77 2.26 4.38 3c.57.78 3.9 3.47 4.51 3.47M488.37 352.26s6.47 5.6 7.5 6.33c1.1.79 7.43 6.95 8.16 7.86M493.61 349.87s5.12 4.08 5.73 5.73c.6 1.65 2.12 3.6 2.12 3.6s2.13 4.2 2.87 4.81c.73.61 2.25 2.22 4.08 3.34M464.41 346.1s5.38 4.56 6.85 5.42M462.16 348.96s5.42 3.77 7.81 4.68c2.43.87 4.38 1.65 9.63 2.4M481.73 358.16s-6.03-.3-7.07 0-5.73-.78-6.94-1.09c-1.22-.26-6.04-1.17-6.64-1.34M472.53 337.81s-.3 3.3.17 4.69c.44 1.34 2.56 5.24 2.39 6.16-.13.9 1.21 4.99 2.43 5.72M478.73 338.42s-1.08 3.3-.6 4.38c.43 1.04 1.16 3 1.16 4.21s.79 3 1.09 3.77c.3.74-.17 3.3.6 4.04.74.78 1.66 2.13 1.66 2.13M446.49 330.74s4.82 1.82 5.42 3c.57 1.21 1.48 1.51 1.96 2.12M464.24 326.23s1.21 4.82.91 6.03c-.3 1.17-.3 3.6-.3 4.51 0 .91-1.35 4.51-1.22 5.12M462.29 322.15l-.6 4.08c-.14 1.17 0 3.16-.31 3.9-.3.74-.74 4.82 0 6.64M449.06 326.23s3.9 3.3 4.82 4.2c.9.92 4.94 5.26 5.12 6.34.13 1.05 2.99 4.34 3.9 5.12M442.42 309.35s3.9 3.9 4.2 4.82c.31.9 1.96 2.38 2.74 2.86M460.77 311s-1.48 2.26-1.48 3c0 .78-.6 2.73-1.21 3.47-.39.52-1.65 2.73-1.52 4.07M459.6 304.66s-.6 2.13-.91 3.6c-.3 1.52-1.09 3.04-1.35 3.95-.3.91-1.51 5.25-1.08 7.98M445.89 304.53s.43 2.08 1.48 3.17c1.08 1.04 2.73 2.56 2.86 3.42.17.92 1.52 5.43 3.04 6.95a5.4 5.4 0 0 1 1.65 3.03M444.37 289.18s.43 2.56.74 3.3c.3.74 1.52 4.08 2.73 5.12M457.34 289.91s-.78 2.08-.91 3c-.17.9-1.09 1.95-1.22 2.42l-.73 1.96M460.03 291.99c-.13.91-1.82 3.64-1.95 4.08-.18.48-1.04 2.56-1.96 3.17-.9.6-3.6 2.56-3.47 3.34M448.27 286.14s-.13 3.3.48 4.51c.6 1.22 1.34 3.04 1.65 3.95.3.87.3 2.39.43 3.43.17 1.08.6 3.04 1.21 3.77M463.81 275.9s-2.17 2.47-3.17 3.47-4.81 5.12-4.99 5.86M460.21 273.64s-2.13 4.64-2.6 5.38c-.44.78-.87 2-.87 2M454.78 273.47s.13 3.64 0 4.56a7.9 7.9 0 0 0 0 2.86c.13.43-.48 3.73-.6 4.51M472.22 264.14s-4.82 2.86-5.55 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.36 260.37l-3.3 4.81-.73 1.39",
    strokeWidth: 0.1344096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.63 259.93s-1.08 2.56-1.21 3.6c-.18 1.09-1.65 4.38-2.26 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.23 257.98s-.48 1.04 1.35.74",
    strokeWidth: 0.26
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(-1 0 0 1 1030.05 0)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00209f",
    d: "M514.57 366.14s.74-1.82 2.26-.17c0 0 1.82 4.25.43 4.38-1.35.17-2.7.43-2.82-.3-.17-.74.13-3.91.13-3.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00209f",
    d: "M516.52 365.54s.48-6.47 1.35-6.77c.9-.3 3.64-1.82 5.29-.48 1.65 1.4.13 8.07-.48 8.68-.56.6-1.47 2.48-4.95 2.04l-.47-1.65s1.82-.17 3.03-.78c1.22-.6 1.61-1.17 1.52-1.78-.17-.9-.08-4.25-1-4.55-.9-.3-2.34-.74-2.34-.74s-1.34 5.03-1.65 6.46l-.3-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44 370.05s-6.2 3.6-3.04 9.03l-2.12-1.35s-1.17 2.13-.13 3.34c0 0-4.21-3.77-.91-8.29 3.34-4.55 6.03-4.25 6.03-4.25l.17 1.52z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44 367.06s-2.73-1.82-6.64-.78c0 0-1.73-5.6-1.08-7.38.3-.82.9-.9.9-.9s-1.95-1.18-1.34 4.07c.6 5.3 1.65 6.77 1.65 6.77s5.12.3 6.34-.3l.17-1.48z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44 367.06s-5.42-9.07-6.81-9.07c0 0-1.56-.22 1.95-.6 1.22-.14 3.17 0 4.08 1.69.91 1.65 1.65 5.55 1.95 6.16 0 0-1.04.3-1.17 1.82z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44 367.06s-3.64-1.7-4.08-2.13c-.48-.43-1.21-5.55-.78-5.25 0 0-1.47-1.69-1.95-1.69-.3 0-1.35.78-1.04 2.56.3 1.82.73 4.56 1.21 5.73 0 0 2.87-1.17 6.64.78z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "#011322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.74 370.05s1.95 1.21 1.95 3.47.91 6.34 2.74 7.25c0 0 .43-1.7 1.04-2 0 0 1.82 2.13 2.39 2.13 0 0-1.05-1.96-1.05-2.87 0-.9-.9-4.38-1.82-5.25-.87-.9-2.69-3.03-5.25-3.77v1.04z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.48 359.51l-1.65 6.46.44 1.4s.6-.18.9-.92c.31-.78 1.22-6.33 1.7-6.5l-1.39-.44z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "#011322"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#011d33",
    d: "M514.35 369.31s-2.95.91-4.08 3.21c0 0-.39-1.48 4-3.6l.08.39zM517.83 369.31s2.04.83 2.56 2.04c0 0-1.95-1.3-2.56-1.52v-.52zM514.35 367.58s-4.6.74-5.6.52c0 0 1.4.3 5.69-.09l-.09-.43zM521.82 364.8s.52 2.3.87 2.17c.39-.17 1.17-3.86 1.21-5.6.09-1.69-.73-2.08-1.43-2-.65.05-1.04 1.57-.95 2.26.04.65.21 2.78.3 3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#011d33",
    d: "M516.83 365.97s1.87 4.17.43 4.38c-1.39.22.61.18-.34-2.69-.4-1.08-1-2.43-1.3-2.43 0 0 1.08.4 1.21.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.57 366.14s.74-1.82 2.26-.17c0 0 1.82 4.25.43 4.38-1.35.17-2.7.43-2.82-.3-.17-.74.13-3.91.13-3.91z",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.52 365.54s.48-6.47 1.35-6.77c.9-.3 3.64-1.82 5.29-.48 1.65 1.4.13 8.07-.48 8.68-.56.6-1.47 2.48-4.95 2.04l-.47-1.65s1.82-.17 3.03-.78c1.22-.6 1.61-1.17 1.52-1.78-.17-.9-.08-4.25-1-4.55-.9-.3-2.34-.74-2.34-.74s-1.34 5.03-1.65 6.46l-.3-.43z",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.13)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00209f",
    d: "M509.84 255.9c-.4-.95-.48-7.38-.4-8.37.14-1.74 3.13-10.24 3.74-11.24.65-1 .48-1.22.74-1.82l.87-1.18a10.88 10.88 0 0 1 1.25 4.13s-.56 4.08-1.04 5.9c-.43 1.82-1.6 4.34-1.82 4.86-.56 1.26-.52 2.43-.17 2.51l-3.17 5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M515.01 247.35l.48.52c1.34-1.43 1.43-4.43 1.43-4.43l-.87-6.03s-.56 4.08-1.04 5.9c-.43 1.83-1.6 4.34-1.82 4.86-.87 2.18-.22 2.43-.18 2.52l2-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00209f",
    d: "M515.48 247.87c1.35-1.43 1.43-4.43 1.43-4.43s.96 4.9.44 5.95c-.52 1.04-.52.74-.44 1.26l-1.43-2.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.91 250.65c-.09-.52-.09-.22.43-1.26.53-1.04-.43-5.94-.43-5.94l-.87-6.03c-.13-1.35-.6-3.04-1.26-4.13l-.86 1.18c-.26.6-.09.82-.74 1.82-.6 1-3.6 9.5-3.73 11.24-.09 1 0 7.42.39 8.37",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.01 234.11s-.09-.95-.17-1.3c-.05-.18.52.87 1 .74.86.26 1.82 1.43 2.08 1.73-.4.56-1.3 1.65-1.96 1.43-.56-.17-.43-1-.6-1.52-.1-.25-.4-.6-.35-1.08z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.05 233.33l.35.4c.21.12.43 0 .7.16.64.44.86.83 1.55 1.52",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.66 233.99c.82.39 1.26 1.04 1.82 1.73 0 0 .05-.08 0-.08",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 233.42s.87-.43 1.17-.6c.18-.1-.65.77-.34 1.16.04.92-.7 2.22-.96 2.56-.65-.17-1.3-.17-1.82-1.17-.22-.34.39-.74.78-1.08.22-.18.7-.74 1.17-.87z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.87 233.16c-.04.09-.26.39-.26.52-.04.22.13.4.09.7-.18.73-.48 1.08-.87 1.99",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.44 233.99c-.09.91-.52 1.52-1 2.3 0-.04.13 0 .13 0",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.44 232.81c.6-.74 1.7-1.39 2.21-.95.05.04.48.3.61.56.26.3.22.43.09.78-.4.78-1.44.4-2.09.04-.13-.08-.52-.43-.73-.34-.35.13-.22.13-.35.13.13.08.26.04.35.08.6.18 1.04.52 1.78.87.52.22 1.47-.48 1.43-.95 0-.57-.91-1.57-1.35-1.57-1 0-1.78.61-2.47 1.4.17-.14.39.12.52-.05z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.87 232.81c-.56-.74-1.65-1.39-2.17-.95-.04.04-.48.3-.6.56-.27.26-.27.43-.1.78.35.78 1.44.4 2.05.04.17-.08.56-.43.78-.34.34.13.21.13.34.13-.13.08-.26.04-.39.08-.56.18-1 .52-1.78.87-.52.22-1.43-.48-1.43-.95.05-.61.96-1.57 1.4-1.57.99 0 1.77.61 2.42 1.4-.13-.14-.35.12-.52-.05z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.09 232.38c-.26-.09-.56.17-.65.35-.09.21.09.56.35.6.34.13.82.05.9-.34.1-.35-.3-.44-.6-.61z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FC0",
    d: "M515.05 226.35s.4 2.34 1.56 4.04-1.43 1.47-1.6 2.08c0 0-.78-1.7-1.6-2.13 0 0 1.3-2.04 1.64-3.95v-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.05 226.35s.4 2.34 1.56 4.04c0 0-1.43 1.47-1.6 2.08 0 0-.78-1.7-1.6-2.13 0 0 1.3-2.04 1.64-3.95",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.01 228.82s.3 1.04.65 1.74c0 0-.56.43-.65.69 0 0-.3-.7-.6-.87 0 0 .56-.9.6-1.56z",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M515.01 344.54c-.09 0-.22-.17-.35-.22-.39-.26-1.12-.26-1.3-.47-1.04-1.18-.35-3.43.09-4.82.87-2.6 1-4.99 1.56-7.46h.04c.57 2.47.7 4.86 1.52 7.46.48 1.39 1.17 3.64.13 4.82-.21.21-.9.21-1.3.47-.13.05-.26.22-.39.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00209f",
    d: "M515.01 331.48c.56 2.47.74 4.99 1.56 7.6.44 1.3 1.09 3.38.3 4.55v-.04c.4 0 .74-.14 1.1-.27.12-.04.25-.08.3-.21.12-.22.3-.4.47-.52.26-.18.57-.05.83-.22.08-.09.13-.17.17-.17.52-.26 1.04-.57 1.26-1.13.13-.4.17-.83.09-1.26-.05-.3-.18-.52-.27-.78l-.52-1.17c-.17-.4-.43-.74-.6-1.13a2.35 2.35 0 0 0-.3-.57c-.1-.17-.22-.34-.31-.52-.09-.17-.3-.3-.44-.47-.17-.18-.21-.18-.34-.3-.05-.05-.26-.1-.22-.18-.09 0-.22-.09-.26-.13-.35-.74-.65-1.13-1-1.87-.17-.3-.21-.86-.21-1.21H515z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00209f",
    d: "M515.01 331.48c-.52 2.47-.7 4.99-1.56 7.6-.4 1.3-1.04 3.38-.26 4.55l-.05-.04h.05c-.4 0-.74-.14-1.13-.27-.09-.04-.22-.08-.3-.21a1.37 1.37 0 0 0-.48-.52c-.22-.18-.52-.05-.78-.22-.09-.09-.13-.17-.22-.17-.52-.26-1-.57-1.21-1.13-.13-.4-.18-.83-.09-1.26.04-.3.17-.52.26-.78l.52-1.17c.17-.4.4-.74.6-1.13.1-.22.18-.4.31-.57.09-.17.17-.34.3-.52.1-.17.3-.3.44-.47.17-.18.22-.18.35-.3.04-.05.26-.1.21-.18.09 0 .22-.09.22-.13.39-.74.7-1.13 1.04-1.87.17-.3.22-.86.22-1.21H515z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b",
    strokeWidth: 0.17,
    strokeMiterlimit: 2.61,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.27 331.57s-1 4.08-1.56 5.12c-.6 1.04-2.95 2.95-1.43 5.9",
    stroke: "#011322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.35 331.57s-.95 4.12-1.56 5.16c-.61 1.09-2.91 3.04-1.35 6",
    stroke: "#011d33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.48 331.57s-1 4.16-1.6 5.25c-.57 1.04-2.87 3.08-1.26 6.03",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.57 331.57s-.95 4.25-1.56 5.3c-.6 1.03-2.87 3.12-1.26 6.15",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.7 331.57s-1 4.3-1.6 5.38c-.61 1.04-2.83 3.17-1.18 6.2",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.18 331.57s-.95 3.95-1.6 5.08c-.61 1.08-2.96 3-1.4 5.9",
    stroke: "#011d33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.05 331.61s-.91 3.77-1.6 5.03c-.61 1.04-2.96 2.95-1.4 5.86",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.96 331.61s-.91 3.64-1.65 4.99c-.56 1.04-2.95 2.95-1.39 5.9",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.83 331.61s-.82 3.56-1.65 4.95c-.56 1.08-2.9 2.95-1.39 5.9",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.75 331.65s-.82 3.38-1.65 4.9c-.6 1.04-2.95 2.95-1.39 5.86",
    stroke: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.79 331.57s-.95 4.38-1.56 5.42c-.6 1.05-2.78 3.26-1.17 6.34",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "matrix(-1 0 0 1 1030.05 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.65 335.17c.13.17.35.3.43.48.1.17.22.35.3.52.14.17.23.35.31.56.17.4.44.74.6 1.13l.53 1.17c.09.26.22.48.26.78.09.44.04.87-.09 1.26-.21.57-.73.87-1.25 1.13-.05 0-.1.09-.18.17-.26.18-.56.05-.82.22-.18.13-.35.3-.48.52-.04.13-.17.18-.3.22-.35.13-.7.26-1.09.26v.04-.04c-.04.09-.13.17-.17.26-.22.22-.91.22-1.3.48-.13.04-.26.21-.4.21-.08 0-.21-.17-.34-.21-.4-.26-1.13-.26-1.3-.48-.09-.09-.13-.17-.18-.26v.04l-.04-.04h.04c-.39 0-.73-.13-1.12-.26-.1-.04-.22-.09-.3-.22a1.37 1.37 0 0 0-.49-.52c-.21-.17-.52-.04-.78-.22-.08-.08-.13-.17-.21-.17-.52-.26-1-.56-1.22-1.13-.13-.39-.17-.82-.08-1.26.04-.3.17-.52.26-.78l.52-1.17c.17-.39.39-.74.6-1.13.1-.21.18-.39.3-.56.1-.17.18-.35.31-.52.09-.18.3-.3.44-.48",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M487.37 293.56c-1.48-3.69-3.04-11.24-2.95-12.97.3-7.12.22-9.24.87-16.53l7.33 8.37c-.17 2.82-.22 3.69 0 5.47.09.65.48 3.86 1 5.12l-6.25 10.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M493.61 283.01c-.52-1.26-.91-4.47-1-5.12-.21-1.78-.17-2.65 0-5.47l4.51 5-3.51 5.59zM474.96 289.91a75.47 75.47 0 0 1-.26-4.3c.04-5.11-.56-7.98 0-13.4.43-4.25 1.47-9.85 1.26-14.45-.09-1.3.17-2.6.21-3.86l9.12 10.15c-.65 7.3-.57 9.42-.87 16.53-.09 1.74 1.47 9.29 2.95 12.97l-1.9 3.21-10.51-6.85zM481.34 303.67c-.6-1-1.13-3.86-1.26-4.43-.3-1.51-.3-2.38-.21-4.98l5.03 3.3-3.56 6.11zM466.97 327.7a5.23 5.23 0 0 1-1.82-2.21c-.61-1.74-.48-1.7-.91-3.6-.26-1.09-.26-2.3-.52-3.43-.22-1.13-1.83-4.73-1.87-6.2-.17-4.73-1.74-7.95-1.35-13.1.27-4 1.18-9.42.74-13.59-.13-1.13.05-2.43.09-3.56l10.24 6.68c-.4 6.86-.22 8.77-.22 15.4-.04 1.61 1.39 8.12 3.13 11.03l-7.51 12.58zM483.98 331.48c1.91 1.74 5.42 2.65 5.99 3.04 1.26.9 3.12 2.25 6.29 2.43 2.34.17 3.38-.44 5.77-.74 2.73-.35-.35.09 2.3-.48 1.34-.34 1.34-.56 3.17-1 1.34-.3 2.69-.65 3.51-1.77.3-.44.57-.79.6-1.48h1.83c.17.52-.35 1.52-.52 1.87l-.48.65c-.26.56-.21.43-.7.87-.12.08-.68.56-.86.65-.34.26-.7.6-1.08.65-1.78.3-2.52.69-4.21 1.17-1.6.48-.74.39-1.95.7-.61.12-1.83.6-2.43.69-1.09.17-1.26.34-2.39.6-2.9.65-5.73.48-8.6.3-1.16-.08-4.03-.69-5.02-1.38-1.78-1.26-5.69-1.74-7.42-2.95-.26-.18-1.35-.7-1.56-.91-1.7-1.4-3.04-1.78-4.82-2.91h12.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M497.74 331.48h13.88c-.04.7-.3 1.04-.6 1.48-.83 1.12-2.17 1.47-3.52 1.77-1.43.35-2.9-.43-4.42-.43-3.65-1.13-4.08-2.26-5.34-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M497.74 331.48c1.26.65 1.87 1.74 5.34 2.82 1.34 0 2.82.6 4.08.57-1.52.34-1.57.56-2.82.86-2.65.57.43.13-2.3.48-2.39.3-3.43.91-5.77.74a10.98 10.98 0 0 1-6.3-2.43c-.56-.4-4.07-1.3-5.98-3.04h13.75z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.17,
    strokeMiterlimit: 2.61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.65 259.71s1.7 14.97 7.5 14.4",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.16 274.03c-2.9.13-4.82-3.56-5.9-7.03a46.5 46.5 0 0 1-1.6-7.33",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.16 273.99c-2.9-.09-4.82-3.82-5.81-7.07a43.45 43.45 0 0 1-1.7-7.3",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.2 273.95c-2.9-.26-4.86-4.08-5.81-7.12-1.13-3.34-1.7-7.15-1.74-7.24",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.2 273.9c-2.9-.48-4.86-4.38-5.77-7.16-1.13-3.25-1.74-7.11-1.78-7.24",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.24 273.82c-2.95-.6-4.9-4.6-5.73-7.16-1.12-3.17-1.82-7.07-1.86-7.2",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.24 273.77c-2.9-.82-4.9-4.86-5.68-7.2a45.91 45.91 0 0 1-1.87-7.16",
    stroke: "#04345b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.29 273.73c-2.95-1-4.95-5.12-5.68-7.29a48.7 48.7 0 0 1-1.91-7.07",
    stroke: "#04365e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.29 273.69c-2.95-1.21-4.95-5.38-5.6-7.33a47.62 47.62 0 0 1-2-7.07",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.29 273.6c-2.9-1.35-4.95-5.64-5.55-7.33-1.13-2.74-2-6.77-2.04-7.03",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33 273.55c-2.95-1.52-4.99-5.9-5.55-7.38a50.33 50.33 0 0 1-2.09-6.98",
    stroke: "#053d6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33 273.51c-2.95-1.74-4.99-6.16-5.47-7.42a45.61 45.61 0 0 1-2.17-6.94",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.37 273.47c-2.95-1.9-5.03-6.42-5.47-7.5-1.08-2.4-2.12-6.56-2.21-6.9",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.69 259.02c.09.39 1.17 4.56 2.26 6.85.39.83 2.47 5.43 5.42 7.51",
    stroke: "#00209f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M476.87 256.33s4.86 11.89 7.94 10.54",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.81 266.87c-1.35.56-3.34-1.82-4.95-4.6-1.73-3.04-3-5.99-3-5.99",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.81 266.83c-1.17.52-3.25-1.78-4.9-4.64-1.78-3.17-3.04-5.95-3.04-5.95",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.81 266.79c-1 .43-3.17-1.74-4.86-4.69a91.75 91.75 0 0 1-3.04-5.9",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.81 266.79c-.82.35-3.12-1.74-4.77-4.77-1.95-3.47-3.13-5.86-3.13-5.86",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.85 266.74c-.7.3-3.08-1.7-4.77-4.82-2-3.64-3.13-5.85-3.13-5.85",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.85 266.74c-.52.22-3-1.7-4.73-4.9a749.46 749.46 0 0 0-3.17-5.82",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.85 266.7c-.35.17-2.9-1.65-4.69-4.95-2.12-3.94-3.16-5.77-3.16-5.77",
    stroke: "#053d6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.85 266.7c-.17.04-2.82-1.65-4.64-4.99-2.17-4.12-3.21-5.77-3.21-5.77",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 255.9s1.04 1.43 3.25 5.73c1.83 3.42 4.6 5.03 4.6 5.03",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.88 278.72l3.77-.7M492.62 274.86l4.08 2.21",
    stroke: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.53 275.03l4.17 2.04",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.53 275.2l4.21 1.91",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.53 275.42l4.21 1.74",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 275.59l4.21 1.61",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 275.77l4.26 1.43",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 275.94l4.3 1.3",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 276.11l4.34 1.18",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 276.33l4.39 1",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.57 276.51l4.43.86",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.83 278.54l3.87-.56",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.83 278.33l3.91-.44",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.79 278.11l3.99-.26",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.79 277.94l4.04-.13",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.75 277.72h4.12",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.75 277.5l4.16.18",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.75 277.33l4.21.26",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.7 277.11l4.34.44",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.7 276.9l4.39.6",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.66 276.72l4.47.7",
    stroke: "#022743"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.96 277.81s.22 3.17.91 4.51c1 1.87 3.9 4.73 7.25 6.81",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.2 289.13a27.13 27.13 0 0 1-5.47-4.64c-.73-.78-1.34-1.6-1.73-2.26-.7-1.39-1-4.51-1-4.51",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.29 289.13a27.18 27.18 0 0 1-5.42-4.73 9.4 9.4 0 0 1-1.7-2.3c-.78-1.39-1.17-4.47-1.17-4.47",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.33 289.13a31.29 31.29 0 0 1-5.34-4.77c-.7-.78-1.3-1.6-1.69-2.35-.82-1.47-1.3-4.46-1.3-4.46",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.42 289.09a31.37 31.37 0 0 1-5.34-4.82 13.6 13.6 0 0 1-1.65-2.34c-.86-1.52-1.43-4.47-1.43-4.47",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.5 289.09c-2.13-1.43-4.04-3.56-5.3-4.9a12.7 12.7 0 0 1-1.64-2.35c-.91-1.56-1.52-4.46-1.52-4.46",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.59 289.09c-2.13-1.48-4.04-3.69-5.25-4.99-.6-.7-1.17-1.52-1.65-2.34-.95-1.65-1.65-4.47-1.65-4.47",
    stroke: "#04345b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.63 289.09c-2.04-1.52-4-3.82-5.16-5.08a13.94 13.94 0 0 1-1.65-2.34c-1-1.7-1.78-4.47-1.78-4.47",
    stroke: "#04365e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.72 289.05c-2.04-1.48-4-3.86-5.12-5.12-.56-.6-1.13-1.48-1.65-2.34a25.88 25.88 0 0 1-1.9-4.47",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.81 289.05c-2.04-1.52-4-4-5.08-5.2a13.74 13.74 0 0 1-1.65-2.35c-1.08-1.82-2-4.47-2-4.47",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.85 289.05c-2-1.52-3.9-4.12-4.99-5.3a16.7 16.7 0 0 1-1.65-2.34 40.98 40.98 0 0 1-2.12-4.47",
    stroke: "#053d6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.94 289.05c-2-1.56-3.9-4.2-4.95-5.34a18.64 18.64 0 0 1-1.65-2.38 50.69 50.69 0 0 1-2.25-4.47",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.03 289c-2-1.56-3.9-4.3-4.9-5.38a16.03 16.03 0 0 1-1.6-2.39c-1.22-2-2.44-4.47-2.44-4.47",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.09 276.68s2.82 5.34 4.17 6.85c.95 1.05 2.86 3.91 4.86 5.47",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.17 289.91c3.08 2.04 3.86 2.56 10.24 6.64l1.95-3s-.74-1.77-1.04-2.6",
    stroke: "#011d33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.22 289.87c2.95 2 3.95 2.65 10.2 6.55l.08-.08c0-.05 1.74-2.91 1.74-2.91s-.09-.35-.3-.78c-.22-.57-.48-1.22-.61-1.7",
    stroke: "#011e34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.22 289.87c2.86 1.91 4.12 2.73 10.2 6.47l.08-.14c0-.08 1.65-2.9 1.65-2.9s-.09-.3-.26-.74c-.22-.52-.43-1.17-.56-1.6",
    stroke: "#022037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.22 289.87a262.6 262.6 0 0 0 10.2 6.33l.08-.13c0-.08 1.56-2.86 1.52-2.86 0 0-.04-.3-.22-.7-.17-.51-.39-1.12-.52-1.56",
    stroke: "#022139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.22 289.83c2.69 1.78 4.47 2.86 10.2 6.25l.08-.13c0-.13 1.43-2.87 1.43-2.87s0-.26-.17-.65a8.23 8.23 0 0 1-.48-1.47",
    stroke: "#02223b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.26 289.83c2.56 1.7 4.6 2.95 10.15 6.12.05 0 .09-.13.09-.13 0-.18 1.34-2.82 1.34-2.87-.04 0 0-.21-.17-.6-.17-.48-.3-.96-.4-1.4",
    stroke: "#02233d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.26 289.78c2.47 1.65 4.77 3.04 10.2 6.03 0 0 .04-.13.08-.13 0-.22 1.22-2.82 1.18-2.82 0 0 .04-.22-.1-.6-.17-.44-.3-.87-.34-1.3",
    stroke: "#022540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.26 289.78c2.39 1.6 4.95 3.08 10.2 5.9l.08-.13c0-.22 1.09-2.78 1.09-2.82 0 0 .09-.17-.09-.52a4.8 4.8 0 0 1-.3-1.26",
    stroke: "#022541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.26 289.78c2.3 1.52 5.12 3.17 10.2 5.81 0-.04.08-.17.08-.17 0-.26 1-2.78.96-2.82 0 0 .13-.13 0-.48a4.1 4.1 0 0 1-.26-1.17",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.3 289.74a92.52 92.52 0 0 0 10.15 5.73c0-.05.09-.13.09-.18 0-.3.87-2.77.87-2.77s.13-.13 0-.48c-.18-.39-.18-.7-.18-1.08",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.3 289.74a80.65 80.65 0 0 0 10.15 5.6.33.33 0 0 0 .09-.18c0-.34.78-2.73.74-2.77 0 0 .21-.13.08-.44-.17-.39-.13-.6-.13-1",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.3 289.74c2 1.3 5.55 3.38 10.15 5.47.05-.05.09-.13.13-.18-.04-.34.65-2.73.61-2.73 0-.04.22-.13.09-.43-.13-.35-.09-.52-.09-.91",
    stroke: "#032a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.35 289.7a67.74 67.74 0 0 0 10.11 5.38l.13-.17c0-.4.52-2.7.48-2.74 0 0 .26-.08.17-.34-.17-.35-.09-.48-.04-.87",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.35 289.7a62.3 62.3 0 0 0 10.11 5.25c.04 0 .13-.13.13-.17 0-.44.43-2.7.39-2.74 0 0 .3-.04.17-.3-.13-.35 0-.4.05-.78",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.35 289.7c1.7 1.08 6.03 3.6 10.15 5.16 0-.04.09-.17.09-.21 0-.44.35-2.65.3-2.7h-.04s.35-.04.26-.3c-.13-.3 0-.3.09-.7",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.35 289.65c1.6 1.08 6.2 3.69 10.15 5.08a.46.46 0 0 0 .09-.22c0-.48.22-2.65.17-2.69l.26-.26c-.13-.26.05-.26.18-.6",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.39 289.65c1.48 1 6.33 3.77 10.11 4.95a.46.46 0 0 0 .09-.22c0-.52.13-2.65.08-2.7 0 0 .4.05.3-.16-.12-.3.1-.22.18-.57",
    stroke: "#033156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.39 289.61c1.39.95 6.5 3.86 10.11 4.86.04-.04.09-.17.13-.22 0-.56-.04-2.6-.09-2.64 0 0 .44.04.35-.18-.09-.26.13-.13.26-.47",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.39 289.61c1.3.87 6.68 3.9 10.11 4.73.04-.04.09-.17.13-.22 0-.56-.13-2.6-.17-2.64 0 0 .43.08.39-.13-.13-.22.13-.05.3-.4",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.39 289.61c1.21.78 6.81 4 10.11 4.6.04-.04.13-.13.13-.22 0-.6-.22-2.56-.3-2.64 0 0 .52.13.43-.1-.09-.2.22.05.39-.3",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.43 289.57c1.08.74 6.94 4.08 10.07 4.56.04-.09.13-.18.13-.26 0-.65-.35-2.56-.4-2.6 0 0 .53.08.44-.05-.04-.22.26.09.43-.26",
    stroke: "#04365e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.43 289.57c1 .65 7.12 4.17 10.07 4.43.08-.1.13-.18.13-.26 0-.65-.44-2.52-.52-2.6 0 0 .56.12.52 0-.1-.18.3.12.47-.18",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.43 289.57c.91.56 7.29 4.2 10.11 4.3l.13-.26c-.04-.7-.56-2.52-.65-2.6 0 0 .6.17.52.04-.04-.18.35.21.56-.09",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.48 289.52c.78.52 7.42 4.3 10.07 4.2.04-.03.08-.16.13-.25 0-.74-.7-2.52-.74-2.56h-.05s.66.17.61.04c-.04-.13.35.3.61 0",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.48 289.52c.7.48 7.6 4.38 10.07 4.08.04-.04.13-.17.13-.26a7.8 7.8 0 0 0-.87-2.56s.65.21.6.13c-.04-.13.44.34.7.04",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.48 289.52c.6.4 7.77 4.43 10.07 3.95.04-.04.13-.18.13-.26 0-.78-.87-2.47-.96-2.52v-.04s.7.26.65.17c-.04-.13.44.44.7.13",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.48 289.48c.52.35 7.94 4.51 10.07 3.9a.47.47 0 0 0 .13-.3c0-.82-1-2.43-1.09-2.51 0 0 .74.26.7.17-.05-.09.47.52.78.22",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52 289.48c.4.26 8.07 4.6 10.02 3.77.09-.08.13-.21.18-.3-.05-.87-1.13-2.43-1.22-2.52 0 0 .74.3.74.22-.05-.04.52.6.82.3",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52 289.48c.3.17 8.2 4.64 10.02 3.64.09-.08.13-.21.18-.3 0-.87-1.26-2.43-1.35-2.47 0 0 .82.3.78.26 0-.09.56.6.91.35",
    stroke: "#053f6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52 289.43c.22.13 8.37 4.73 10.02 3.56a.7.7 0 0 0 .18-.3c0-.92-1.35-2.4-1.44-2.48 0 0 .83.35.83.3-.05-.04.6.7.9.44",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.52 289.43c.13.04 8.55 4.82 10.07 3.43.04-.09.13-.18.13-.3 0-.96-1.44-2.4-1.57-2.48l.87.35s.65.78 1 .52",
    stroke: "#064374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.57 289.39s9.72 5.47 10.15 3.04c0-1-1.65-2.43-1.65-2.43l.91.34s.66.87 1.05.61",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.44 315.12l-7.55 12.58a5.23 5.23 0 0 1-1.82-2.21c-.57-1.74-.48-1.74-.91-3.6-.22-1.09-.26-2.3-.48-3.43-.26-1.13-1.87-4.73-1.91-6.2",
    stroke: "#011d33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.48 1.65 4.99 1.91 6.12.22 1.13.26 2.34.48 3.43.43 1.86.34 1.82.95 3.55a5.15 5.15 0 0 0 1.78 2.22c.04 0 7.5-12.46 7.55-12.46",
    stroke: "#011d33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.43 1.65 4.95 1.87 6.07.26 1.13.3 2.3.56 3.39.43 1.82.3 1.82.91 3.56.3.82 1.26 1.82 1.78 2.17.04 0 7.46-12.28 7.55-12.33",
    stroke: "#011e34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.43 1.6 4.9 1.87 6.03.26 1.09.3 2.26.56 3.34.43 1.82.3 1.78.91 3.52.3.82 1.26 1.78 1.78 2.12.09.05 7.46-12.1 7.55-12.15",
    stroke: "#011e34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.39 1.6 4.86 1.87 5.94.26 1.13.3 2.26.56 3.34.43 1.78.35 1.78.91 3.48a5.5 5.5 0 0 0 1.78 2.12c.13.05 7.42-11.97 7.55-12.02",
    stroke: "#011f36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.39 1.6 4.82 1.87 5.9.26 1.09.3 2.26.56 3.3.43 1.78.35 1.73.95 3.43.3.82 1.22 1.77 1.78 2.12.09.05 7.34-11.84 7.51-11.89",
    stroke: "#011f36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.39 1.56 4.73 1.87 5.81.26 1.09.3 2.26.56 3.3.43 1.74.35 1.74.95 3.38.3.83 1.22 1.78 1.78 2.13.13.05 7.34-11.71 7.51-11.76",
    stroke: "#022037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.35 1.56 4.69 1.87 5.77.26 1.09.3 2.21.56 3.26.43 1.73.39 1.73.95 3.33.3.83 1.22 1.78 1.78 2.09.18.08 7.3-11.5 7.51-11.59",
    stroke: "#022037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.35 1.56 4.64 1.87 5.73.26 1.04.3 2.17.56 3.2.43 1.7.39 1.7 1 3.35.3.78 1.21 1.69 1.73 2.04.18.04 7.3-11.37 7.51-11.46",
    stroke: "#022139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.3 1.56 4.6 1.87 5.64.26 1.09.3 2.17.56 3.21.43 1.7.39 1.7 1 3.3.3.78 1.21 1.69 1.73 2.04.22.04 7.25-11.24 7.51-11.33",
    stroke: "#022139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.3 1.52 4.56 1.87 5.6.26 1.04.3 2.12.6 3.16.44 1.7.35 1.65.96 3.26.3.78 1.21 1.7 1.73 2.04.26.04 7.2-11.11 7.51-11.2",
    stroke: "#022139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.3 1.52 4.47 1.87 5.55.26 1 .3 2.13.6 3.08.44 1.7.4 1.7.96 3.26.3.78 1.21 1.69 1.73 2 .26.08 7.2-10.94 7.51-11.03",
    stroke: "#02223b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.26 1.52 4.43 1.87 5.47.26 1.04.3 2.12.6 3.08.44 1.69.4 1.69 1 3.2.3.79 1.17 1.66 1.7 2 .3.09 7.15-10.76 7.5-10.89",
    stroke: "#02223b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.26 1.52 4.38 1.87 5.42.26 1 .3 2.09.6 3.04.44 1.65.4 1.65 1 3.21.3.74 1.17 1.6 1.74 1.95.3.1 7.07-10.63 7.46-10.76",
    stroke: "#02233d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.22 1.48 4.34 1.87 5.38.26 1 .3 2.04.6 3 .44 1.64.44 1.64 1 3.16.3.74 1.22 1.6 1.74 1.95.3.09 7.07-10.5 7.46-10.63",
    stroke: "#02233d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.22 1.48 4.3 1.87 5.3.26 1 .34 2.03.6 2.99.44 1.6.44 1.6 1 3.12.35.74 1.22 1.6 1.74 1.91.34.13 7.03-10.33 7.46-10.46",
    stroke: "#02233e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.26c.04 1.17 1.48 4.2 1.87 5.25.26 1 .34 2 .6 2.95.44 1.6.44 1.6 1.04 3.08.3.74 1.18 1.6 1.7 1.91.39.13 7.03-10.2 7.46-10.33",
    stroke: "#02233e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.22 1.48 4.2 1.82 5.25.3.95.4 2 .65 2.9.44 1.57.44 1.61 1.04 3.05a5.2 5.2 0 0 0 1.7 1.9c.39.14 6.98-10.02 7.46-10.19",
    stroke: "#022540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.22 1.43 4.17 1.82 5.16.3.96.4 2 .65 2.91.48 1.56.48 1.56 1.04 3.04.3.7 1.18 1.52 1.7 1.82.43.13 6.94-9.85 7.46-10.02",
    stroke: "#022540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.17 1.43 4.12 1.82 5.12.26.95.4 1.95.7 2.86.43 1.52.43 1.57 1.04 3 .3.7 1.13 1.52 1.65 1.82.47.13 6.94-9.72 7.46-9.9",
    stroke: "#022540"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.17 1.43 4.04 1.82 5.08.26.9.4 1.9.7 2.82.43 1.52.43 1.52 1.04 2.95a5.2 5.2 0 0 0 1.65 1.82c.47.13 6.9-9.59 7.46-9.76",
    stroke: "#022541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.13 1.43 4 1.82 4.99.26.96.4 1.9.7 2.82.43 1.48.47 1.52 1.04 2.9.3.7 1.17 1.53 1.69 1.83.48.13 6.86-9.46 7.42-9.63",
    stroke: "#022541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.13 1.39 3.95 1.82 4.95.26.9.4 1.86.7 2.77.43 1.48.47 1.48 1.04 2.87.34.7 1.17 1.47 1.69 1.78.52.17 6.81-9.24 7.42-9.46",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.13 1.39 3.9 1.82 4.9.26.87.4 1.87.7 2.74.43 1.43.47 1.47 1.08 2.86.3.65 1.13 1.43 1.65 1.74.52.17 6.77-9.12 7.42-9.33",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.09 1.39 3.86 1.82 4.82.26.9.4 1.86.7 2.73.43 1.43.47 1.48 1.08 2.82.3.65 1.13 1.43 1.65 1.74.56.17 6.77-8.99 7.42-9.2",
    stroke: "#022845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.09 1.39 3.77 1.82 4.77.26.87.4 1.83.7 2.7.43 1.38.52 1.43 1.08 2.77a5.3 5.3 0 0 0 1.65 1.74c.6.17 6.72-8.86 7.42-9.07",
    stroke: "#022845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.04 1.35 3.73 1.82 4.73.26.87.4 1.78.7 2.65.47 1.39.52 1.43 1.08 2.73a4.75 4.75 0 0 0 1.65 1.7c.6.21 6.68-8.69 7.42-8.9",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.04 1.35 3.69 1.82 4.64.26.87.4 1.78.74 2.65.43 1.35.48 1.39 1.08 2.69.3.65 1.13 1.39 1.61 1.7.65.21 6.68-8.56 7.42-8.82",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1.04 1.35 3.64 1.82 4.6.26.87.4 1.73.74 2.56.43 1.39.52 1.43 1.08 2.69.3.65 1.13 1.39 1.61 1.7.7.17 6.64-8.38 7.42-8.69",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1 1.35 3.6 1.82 4.56.26.82.4 1.73.74 2.51.43 1.35.52 1.44 1.08 2.7.35.6 1.13 1.34 1.65 1.64.65.18 6.6-8.24 7.38-8.54",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04 1 1.3 3.51 1.82 4.47.26.82.4 1.73.74 2.52.43 1.34.52 1.38 1.08 2.64.35.61 1.13 1.35 1.65 1.6.7.23 6.55-8.06 7.38-8.37",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04.96 1.3 3.47 1.82 4.43.26.82.44 1.69.74 2.47.43 1.3.52 1.39 1.13 2.6.3.61 1.08 1.35 1.6 1.6.74.23 6.51-7.93 7.38-8.24",
    stroke: "#032a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 312.21c.04.96 1.3 3.43 1.78 4.38.3.78.48 1.65.78 2.43.43 1.3.56 1.35 1.13 2.56.35.61 1.08 1.3 1.6 1.6.74.23 6.51-7.8 7.38-8.1",
    stroke: "#032a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .96 1.21 3.38 1.74 4.3.3.82.47 1.64.78 2.43.43 1.25.56 1.34 1.12 2.51.35.61 1.13 1.3 1.61 1.56.78.26 6.46-7.59 7.38-7.94",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .91 1.21 3.34 1.74 4.25.3.78.47 1.6.78 2.39.47 1.26.56 1.34 1.17 2.52.3.56 1.08 1.25 1.56 1.52.82.25 6.42-7.47 7.38-7.81",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .91 1.21 3.25 1.74 4.17.3.78.47 1.64.78 2.38.47 1.26.56 1.3 1.17 2.48.3.56 1.08 1.25 1.56 1.51.82.26 6.42-7.33 7.38-7.67",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .87 1.21 3.21 1.74 4.12.3.78.47 1.6.82 2.35.43 1.21.56 1.3 1.13 2.43a5.19 5.19 0 0 0 1.56 1.51c.87.27 6.38-7.2 7.38-7.55",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .87 1.17 3.17 1.74 4.08.3.74.47 1.56.82 2.3.43 1.21.56 1.26 1.13 2.39a4.71 4.71 0 0 0 1.6 1.47c.87.3 6.34-7.03 7.34-7.38",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .87 1.17 3.12 1.74 4 .3.77.47 1.55.82 2.3.43 1.16.56 1.25 1.17 2.34.3.56 1.04 1.21 1.56 1.47.87.26 6.3-6.86 7.34-7.25",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .83 1.17 3.08 1.74 3.95.3.74.47 1.52.82 2.25.43 1.18.6 1.22 1.17 2.35a4.9 4.9 0 0 0 1.56 1.43c.91.26 6.25-6.73 7.34-7.11",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .83 1.17 3 1.74 3.9.3.74.47 1.48.82 2.22.43 1.13.6 1.21 1.17 2.3a5.4 5.4 0 0 0 1.56 1.43c.96.26 6.25-6.6 7.34-6.98",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .78 1.13 2.95 1.74 3.82.3.74.47 1.52.82 2.21.43 1.13.6 1.22 1.17 2.26a4.7 4.7 0 0 0 1.56 1.39c.96.3 6.2-6.43 7.34-6.81",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .78 1.13 2.9 1.74 3.77.3.7.47 1.48.82 2.17.43 1.09.6 1.18 1.21 2.22a5.09 5.09 0 0 0 1.52 1.39c1 .3 6.2-6.3 7.34-6.68",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .74 1.13 2.87 1.74 3.73.3.7.47 1.43.82 2.13.48 1.08.65 1.17 1.21 2.17a5.09 5.09 0 0 0 1.52 1.39c1.04.3 6.16-6.12 7.34-6.55",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .74 1.13 2.82 1.74 3.64.3.7.47 1.44.82 2.13.48 1.04.65 1.13 1.21 2.17a5.14 5.14 0 0 0 1.57 1.35c1 .3 6.07-6 7.29-6.42",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .74 1.08 2.73 1.74 3.6.3.7.47 1.39.86 2.08.44 1.05.61 1.13 1.17 2.13a4.47 4.47 0 0 0 1.57 1.3c1.04.35 6.07-5.81 7.29-6.24",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .7 1.08 2.7 1.74 3.56.26.65.52 1.34.86 2 .44 1.04.65 1.17 1.22 2.12a5.4 5.4 0 0 0 1.52 1.3c1.08.35 6.03-5.68 7.29-6.12",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .7 1.08 2.65 1.7 3.47.3.65.56 1.39.9 2 .44 1.04.65 1.13 1.22 2.08a5.4 5.4 0 0 0 1.52 1.3c1.08.35 5.99-5.55 7.29-5.98",
    stroke: "#033156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .65 1.08 2.6 1.7 3.43.3.65.56 1.34.9 1.95.44 1 .65 1.13 1.22 2.04a5.4 5.4 0 0 0 1.52 1.3c1.13.3 5.99-5.38 7.29-5.86",
    stroke: "#033156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .65 1.04 2.56 1.7 3.38.3.61.56 1.3.9 1.91.44 1 .65 1.09 1.26 2.04.35.48 1 1 1.48 1.22 1.17.35 5.94-5.2 7.29-5.69",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.21c0 .65 1.04 2.47 1.7 3.3.3.65.56 1.3.9 1.9.44.96.7 1.1 1.26 2 .35.48 1 1 1.48 1.22 1.17.35 5.94-5.08 7.29-5.56",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .65 1.04 2.47 1.7 3.3.3.6.56 1.26.9 1.86.48.96.7 1.09 1.26 1.96.35.47 1 .95 1.48 1.21 1.21.35 5.9-4.94 7.29-5.42",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .65 1.04 2.43 1.7 3.25.3.61.56 1.22.9 1.83.48.9.7 1.04 1.26 1.9.4.48 1 .96 1.52 1.18 1.22.39 5.81-4.78 7.25-5.25",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .6 1 2.39 1.7 3.17.3.6.56 1.26.95 1.82.43.91.7 1.04 1.26 1.87.34.47 1 .95 1.47 1.17 1.22.39 5.81-4.6 7.25-5.12",
    stroke: "#04345b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .6 1 2.3 1.7 3.12.3.57.56 1.22.95 1.78.43.87.7 1 1.26 1.83.34.47 1 .95 1.47 1.17 1.26.39 5.77-4.47 7.25-5",
    stroke: "#04345b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .6 1 2.26 1.7 3.08.3.56.56 1.17.95 1.74.43.86.7 1 1.26 1.82.34.43 1 .91 1.47 1.13 1.3.39 5.77-4.34 7.25-4.86",
    stroke: "#04345b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .56.95 2.21 1.7 3 .3.56.56 1.17.95 1.73.43.83.7.96 1.26 1.78.39.43 1 .87 1.47 1.09 1.3.43 5.73-4.17 7.25-4.69",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .56.95 2.17 1.7 2.95.3.56.56 1.13.95 1.7.43.82.73.95 1.3 1.73.35.43.95.87 1.43 1.08 1.35.44 5.69-4.03 7.25-4.55",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .52.95 2.13 1.7 2.9.3.53.56 1.1.95 1.66.43.82.73.95 1.3 1.69.35.43.95.87 1.43 1.08 1.39.44 5.69-3.9 7.25-4.42",
    stroke: "#04365e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .52.95 2.04 1.7 2.82.3.52.56 1.13.95 1.65.47.78.73.91 1.3 1.65.39.43 1 .87 1.43 1.08 1.39.4 5.64-3.73 7.25-4.3",
    stroke: "#04365e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .52.91 2 1.7 2.78.3.52.56 1.08.95 1.6.47.78.78.91 1.3 1.65.39.4 1 .83 1.47 1 1.4.43 5.56-3.56 7.2-4.12",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .48.91 1.95 1.7 2.73.3.48.56 1.05.95 1.57.47.73.78.86 1.34 1.6.35.4.96.78 1.43 1 1.44.43 5.56-3.43 7.2-4",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .48.91 1.91 1.65 2.65.35.52.65 1.04 1.04 1.56.43.74.74.87 1.3 1.56.35.4.96.78 1.43 1 1.44.43 5.51-3.3 7.2-3.9",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .43.91 1.87 1.65 2.6.35.48.65 1 1.04 1.48.43.74.74.91 1.3 1.56.4.4.96.78 1.43 1 1.48.43 5.51-3.17 7.2-3.77",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .43.87 1.78 1.65 2.52.35.52.65 1 1.04 1.47.43.74.78.87 1.35 1.52.34.4.9.78 1.38.96 1.52.47 5.47-2.95 7.2-3.6",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .43.87 1.74 1.65 2.47.35.48.65 1 1.04 1.44.43.69.78.86 1.35 1.52.34.34.9.73 1.38.9 1.52.48 5.43-2.81 7.2-3.46",
    stroke: "#043963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .4.87 1.7 1.65 2.43.35.43.65.96 1.04 1.39.43.7.78.82 1.35 1.47.39.35.95.7 1.38.92 1.57.47 5.43-2.7 7.2-3.34",
    stroke: "#043963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .4.87 1.65 1.65 2.34.35.48.65.96 1.04 1.4.48.64.83.82 1.35 1.42.39.35.95.7 1.38.92 1.61.47 5.38-2.56 7.2-3.21",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .35.82 1.6 1.65 2.3.35.43.65.91 1.04 1.35.48.65.83.82 1.39 1.38.35.35.91.7 1.39.87 1.6.52 5.3-2.38 7.16-3.04",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .35.82 1.52 1.65 2.26.35.43.65.86 1.04 1.3.48.6.83.78 1.39 1.34.39.35.91.7 1.39.87 1.6.48 5.3-2.21 7.16-2.9",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .35.82 1.48 1.65 2.17.35.43.65.87 1.08 1.3.44.61.79.78 1.35 1.35.39.3.91.65 1.39.82 1.65.48 5.25-2.08 7.16-2.78",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .3.82 1.43 1.65 2.13.35.39.65.86 1.08 1.26.44.56.83.73 1.35 1.3.39.3.91.6 1.39.78 1.69.52 5.25-1.91 7.16-2.6",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .3.78 1.39 1.65 2.08.35.4.65.83 1.08 1.22.44.56.83.74 1.4 1.26.34.3.9.6 1.34.78 1.69.52 5.2-1.78 7.16-2.47",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .26.78 1.35 1.65 2 .3.39.65.82 1.08 1.21.44.52.83.7 1.4 1.22.38.3.9.6 1.34.78 1.73.52 5.16-1.65 7.16-2.35",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .26.78 1.26 1.65 1.95.3.4.65.78 1.08 1.17.44.53.87.7 1.4 1.18.38.3.9.6 1.34.78 1.78.52 5.16-1.48 7.16-2.21",
    stroke: "#053d6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .22.78 1.22 1.65 1.91.3.35.65.74 1.08 1.13.48.48.87.7 1.4 1.13.38.3.9.6 1.34.73 1.78.57 5.12-1.3 7.16-2.04",
    stroke: "#053d6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .22.74 1.17 1.65 1.82.3.4.65.74 1.08 1.13.48.48.87.65 1.44 1.13.39.26.86.52 1.34.7 1.78.56 5.08-1.18 7.12-1.92",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .22.74 1.13 1.6 1.78l1.13 1.09c.48.43.87.65 1.44 1.08.39.26.86.52 1.34.7 1.82.56 5.03-1.05 7.12-1.78",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .17.74 1.09 1.6 1.74.35.3.74.7 1.13 1.04.48.43.91.6 1.44 1.04.39.26.86.52 1.34.7 1.82.56 5-.92 7.12-1.65",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .17.74 1 1.6 1.65.35.35.74.7 1.18 1.04.43.4.86.6 1.43 1 .35.26.87.52 1.3.65 1.87.56 5-.7 7.12-1.48",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .13.7.96 1.6 1.6.35.31.74.66 1.18.96.43.43.86.65 1.43 1 .39.26.87.48 1.3.65 1.91.56 4.95-.56 7.12-1.34",
    stroke: "#053f6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .13.7.91 1.6 1.56.35.3.74.61 1.18.91.43.4.86.61 1.43 1 .39.22.87.44 1.3.61 1.91.56 4.9-.43 7.12-1.22",
    stroke: "#053f6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .13.7.87 1.6 1.48.35.3.74.6 1.18.9.43.4.9.61 1.43.96.39.22.87.44 1.3.61 1.95.56 4.9-.3 7.12-1.09",
    stroke: "#053f6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .09.65.78 1.6 1.43.35.26.74.57 1.18.87.47.4.9.56 1.47.91.4.22.83.44 1.26.57 2 .6 4.86-.13 7.12-.92",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .09.65.74 1.6 1.39.35.26.74.56 1.18.82.47.35.9.57 1.47.87.4.22.83.44 1.3.57 1.96.6 4.82 0 7.08-.79",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.17c0 .04.65.7 1.6 1.3.35.26.74.57 1.18.83.47.34.95.56 1.47.82.4.22.87.4 1.3.57 2 .6 4.78.17 7.08-.66",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.13c0 .09.65.7 1.6 1.3.35.26.74.52 1.18.78.47.3.95.52 1.47.83l1.3.52c2.04.6 4.73.3 7.08-.52",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.13c0 .09.6.65 1.6 1.26.35.22.74.48 1.18.74.47.3.95.52 1.52.78.39.17.82.34 1.25.47 2.04.66 4.73.48 7.08-.34",
    stroke: "#064374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.13c0 .04.6.56 1.6 1.17.35.26.74.48 1.22.74.43.26.91.48 1.48.74.39.17.82.35 1.25.47 2.09.66 4.69.61 7.08-.21",
    stroke: "#064374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81 312.13c0 .04.6.52 1.6 1.13a23.33 23.33 0 0 0 2.7 1.39c.39.17.82.34 1.25.48 2.13.6 4.65.73 7.08-.1M461.81 312.13s6.47 5.08 12.63 2.9",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M461.55 292.17s1.26 8.11 1.74 9.28c.43 1.05 2.99 5.69 6.9 6.77",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.55 292.17s1.35 8.03 1.87 9.2c.43 1.04 2.82 5.47 6.8 6.81",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.59 292.13s1.39 7.98 1.91 9.2c.43 1.04 2.69 5.2 6.72 6.85",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.59 292.13s1.48 7.94 2 9.11c.47 1.04 2.51 5 6.63 6.9",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.64 292.13s1.52 7.85 2.04 9.03a15.2 15.2 0 0 0 6.6 6.94",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.64 292.13s1.6 7.8 2.17 8.98a15.83 15.83 0 0 0 6.46 6.99",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.64 292.08s1.7 7.77 2.26 8.94c.52 1.08 2.04 4.25 6.37 7.03",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.68 292.08s1.73 7.72 2.3 8.9c.52 1.08 1.9 3.99 6.29 7.07",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.68 292.08s1.82 7.64 2.39 8.8c.56 1.1 1.78 3.78 6.24 7.12",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.72 292.04s1.87 7.64 2.47 8.76c.57 1.13 1.57 3.52 6.12 7.2",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.72 292.04s2 7.55 2.56 8.72c.56 1.09 1.43 3.25 6.03 7.2",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 292.04s2.04 7.5 2.6 8.63c.61 1.13 1.3 3.04 6 7.25",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77 291.99s2.13 7.46 2.69 8.6c.6 1.12 1.17 2.81 5.9 7.32",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.07 287.18s1.04 11.46 9.2 14.62",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.07 287.18c.04.04.48 3.69 2.13 7.25 1.3 2.73 3.47 5.85 7.07 7.33",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.11 287.18c0 .04.52 3.77 2.17 7.2 1.21 2.52 3.38 5.77 6.98 7.38",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.11 287.18c.04.09.65 3.9 2.26 7.12 1.17 2.34 3.3 5.72 6.9 7.41",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.16 287.18c0 .09.74 4 2.34 7.07 1.04 2.17 3.17 5.64 6.77 7.42",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.16 287.18c.04.13.87 4.08 2.43 6.99.95 2 3.12 5.6 6.68 7.5",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 287.18c0 .13.95 4.17 2.47 6.94.91 1.78 3.04 5.51 6.6 7.5",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 287.14c.04.22 1.08 4.34 2.56 6.94.82 1.56 2.95 5.43 6.5 7.5",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 287.14c.09.22 1.21 4.43 2.65 6.86.78 1.43 2.86 5.38 6.42 7.54",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 287.14c.04.26 1.3 4.51 2.69 6.81.7 1.22 2.78 5.3 6.34 7.6",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 287.14c.09.26 1.43 4.6 2.82 6.73.6 1.04 2.65 5.25 6.2 7.63",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29 287.14c.04.3 1.52 4.73 2.86 6.68.52.83 2.56 5.17 6.12 7.64",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29 287.14c.09.3 1.65 4.82 2.95 6.6.48.65 2.47 5.12 6.03 7.72",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M462.16 284.01s2.39 9.2 9.03 11.46",
    stroke: "#022743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.16 284.01s.91 3.25 3.08 6.42c1.43 2.13 3.51 4.21 5.94 5.03",
    stroke: "#022847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.16 283.97s.95 3.21 3.12 6.38c1.52 2.17 3.65 4.34 5.9 5.12",
    stroke: "#032a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.16 283.93s1 3.17 3.21 6.33c1.56 2.22 3.73 4.47 5.81 5.17",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 283.88s1 3.12 3.25 6.33c1.61 2.22 3.87 4.56 5.73 5.21",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 283.88s1.04 3.04 3.34 6.25c1.65 2.25 3.95 4.68 5.69 5.25",
    stroke: "#033156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 283.84s1.08 3.04 3.38 6.2c1.74 2.35 4.13 4.82 5.65 5.34",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2 283.79s1.13 3 3.47 6.16c1.78 2.39 4.21 4.95 5.56 5.43",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 283.79s1.08 2.9 3.51 6.12c1.83 2.38 4.34 5.03 5.47 5.42",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 283.75s1.13 2.86 3.6 6.07c1.87 2.43 4.43 5.21 5.38 5.52",
    stroke: "#043963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 283.71s1.17 2.82 3.64 6.03c1.91 2.47 4.6 5.34 5.34 5.6",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.25 283.66s1.21 2.78 3.73 6.03c1.95 2.52 4.69 5.42 5.25 5.6",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29 283.66s1.21 2.69 3.77 5.94c2 2.56 4.82 5.56 5.17 5.69",
    stroke: "#053f6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29 283.62s1.26 2.65 3.86 5.9c2.04 2.6 4.9 5.69 5.12 5.77",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.29 283.58s1.3 2.6 3.9 5.86c2.13 2.64 5.08 5.81 5.08 5.81",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M479.9 296.55l4.56.83M480.38 300.02l4.08-1.73",
    stroke: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.86 296.68l4.56.7",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.86 296.85l4.6.57",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9 297.03l4.6.39",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9 297.2l4.65.26",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.9 297.38l4.69.08",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.95 297.55l4.68-.04",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.95 297.68l4.73-.17",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.95 297.85l4.77-.3",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.99 298.03l4.77-.48",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.34 299.81l4.16-1.61",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.29 299.63l4.26-1.52",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.29 299.46l4.3-1.39",
    stroke: "#053b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.25 299.28l4.38-1.3",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.21 299.11l4.47-1.17",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.21 298.94l4.51-1.09",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.16 298.72l4.6-.91",
    stroke: "#032f53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.12 298.55l4.69-.83",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.12 298.37l4.73-.69",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.08 298.2l4.81-.61",
    stroke: "#022743"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M484.24 331.57s-2.43.13-2.65.22c-.26.04-9.89-.18-9.89-.18",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.29 331.61s-2.39.22-2.73.3c-.4.05-9.77-.26-9.77-.26",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.29 331.65s-2.3.3-2.78.39c-.52.09-9.63-.35-9.63-.35",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33 331.7s-2.26.35-2.86.48c-.65.13-9.55-.44-9.55-.44",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33 331.7s-2.17.48-2.95.6c-.74.18-9.37-.51-9.37-.51",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33 331.74s-2.08.52-3 .7c-.86.21-9.24-.61-9.24-.61",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.37 331.78s-2.04.6-3.08.82c-1 .18-9.11-.73-9.11-.73",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.37 331.83s-2 .7-3.12.91c-1.13.22-9.03-.78-9.03-.78",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.42 331.87s-1.95.74-3.21 1-8.9-.87-8.9-.87",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.42 331.91s-1.87.82-3.25 1.08c-1.4.3-8.77-.95-8.77-.95",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.48 332.09s7.12 1.35 8.63 1.04c1.52-.3 3.34-1.17 3.34-1.17",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.06 337.07s4.56.7 4.73.65l2.73-.17c.05 0 2.22-.52 2.22-.52",
    stroke: "#022a49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.8 336.99s4.69.74 5.03.65c.18-.04 2.52-.17 2.65-.17.13 0 2.08-.48 2.08-.48",
    stroke: "#032d4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.54 336.86s4.82.83 5.3.7c.25-.05 2.38-.18 2.6-.18.17 0 1.9-.43 1.9-.43",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.28 336.73s4.9.87 5.6.74a56.9 56.9 0 0 1 2.51-.18l1.74-.34",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.02 336.64s5.03.91 5.86.74c.43-.09 2.17-.18 2.47-.22.3 0 1.56-.26 1.56-.26",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.76 336.51s5.16 1 6.16.78c.52-.09 2-.17 2.39-.22.34 0 1.39-.21 1.39-.21",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.5 336.38s5.25 1.08 6.42.87c.65-.13 1.91-.22 2.34-.26.44-.05 1.22-.18 1.22-.18",
    stroke: "#053d6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.24 336.29s5.38 1.13 6.72.87c.7-.18 1.74-.26 2.26-.26.48-.05 1.09-.09 1.09-.09",
    stroke: "#064171"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M486.33 337.2l4.42.62 2.82-.14 2.39-.6",
    strokeWidth: 0.17576640000000002
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.98 336.16s5.51 1.21 7.03.91c1.47-.3 3.08-.3 3.08-.3",
    stroke: "#00209f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M505.76 336.81l4.3-1.56c2.69-1 2.99-3.69 2.99-3.69",
    stroke: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46 335.95s1.74-.7 3.17-1.21c3.82-1.44 3.38-3.26 3.38-3.26",
    stroke: "#00209f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.2 336.12l3.43-1.3c.6-.22 1.39-.57 1.78-.83a4.7 4.7 0 0 0 1.34-1.21c.35-.52.35-1.26.35-1.26",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.94 336.34s2.82-1.08 3.69-1.39c.43-.17 1.47-.6 1.73-.78.4-.26 1.3-1 1.44-1.22a5.7 5.7 0 0 0 .43-1.43",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.68 336.51l3.95-1.48c.3-.08 1.52-.6 1.7-.69a16.7 16.7 0 0 0 1.51-1.26c.17-.26.48-1.56.48-1.56",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.42 336.73s3.9-1.47 4.2-1.56c.14-.09 1.61-.6 1.7-.7a15.2 15.2 0 0 0 1.56-1.25c.09-.13.57-1.65.57-1.65",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46 336.86l4.64-1.74c.83-.3 1.7-1.04 2.08-1.56.57-.82.79-2 .79-2",
    stroke: "#053e6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.11 336.86s4.17-1.52 5.03-1.87c.61-.21 1.7-1.08 1.96-1.47.43-.6.73-1.95.73-1.95",
    stroke: "#043862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.81 336.9s4.82-1.82 5.38-2a8.16 8.16 0 0 0 1.87-1.43c.3-.43.69-1.9.69-1.9",
    stroke: "#043258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.5 336.9s5.42-2.04 5.73-2.13c.21-.08 1.65-1.21 1.78-1.34.13-.22.65-1.87.65-1.87",
    stroke: "#032c4d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022743",
    d: "M504.16 336.9l6.12-2.26 1.64-1.25.61-1.83",
    strokeWidth: 0.17576640000000002
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.27 331.57s-2.52.13-2.78.22c-.26.04-10.28-.18-10.28-.18",
    stroke: "#032b4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.32 331.61s-2.47.22-2.86.3c-.4.05-10.16-.26-10.16-.26",
    stroke: "#032e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.32 331.65s-2.39.3-2.9.39c-.53.09-10.03-.35-10.03-.35",
    stroke: "#033054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.32 331.7s-2.3.35-2.95.48c-.65.13-9.9-.44-9.9-.44",
    stroke: "#043359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.36 331.7s-2.26.48-3.04.6c-.78.18-9.76-.51-9.76-.51",
    stroke: "#04355c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.36 331.74s-2.17.52-3.08.7c-.91.21-9.68-.61-9.68-.61",
    stroke: "#043760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.4 331.78s-2.13.6-3.17.82c-1.08.18-9.54-.73-9.54-.73",
    stroke: "#053a65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.4 331.83s-2.04.7-3.25.91c-1.18.22-9.38-.78-9.38-.78",
    stroke: "#053c68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.45 331.87s-2.04.74-3.34 1c-1.3.26-9.24-.87-9.24-.87",
    stroke: "#053f6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.45 331.91s-1.95.82-3.38 1.08c-1.44.3-9.12-.95-9.12-.95",
    stroke: "#064172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.99 332.09s7.46 1.35 9.03 1.04c1.56-.3 3.47-1.17 3.47-1.17",
    stroke: "#00209f"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.17,
    strokeMiterlimit: 2.61,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.96 289.91a34 34 0 0 1-.17-3.21c.04-5.16-.65-9.07-.1-14.5.44-4.24 1.48-9.84 1.27-14.44-.09-1.3.17-2.6.21-3.86l20.96 23.52M466.97 327.7a5.23 5.23 0 0 1-1.82-2.21c-.61-1.74-.48-1.7-.91-3.6-.26-1.09-.26-2.3-.52-3.43-.22-1.13-1.83-4.73-1.87-6.2-.17-4.73-1.74-7.95-1.35-13.1.27-4 1.18-9.42.74-13.59-.13-1.13.05-2.43.09-3.56l23.56 15.58M513.44 331.48c.17.52-.35 1.52-.52 1.87l-.48.65c-.26.56-.21.43-.7.87-.12.08-.69.56-.86.65-.35.26-.7.6-1.08.65-1.78.3-2.52.69-4.21 1.17-1.6.48-.74.39-1.95.7-.61.12-1.83.6-2.43.69-1.09.17-1.26.34-2.4.6-2.9.65-5.72.48-8.58.3-1.17-.08-4.04-.69-5.03-1.38-1.78-1.26-5.69-1.74-7.42-2.95-.26-.18-1.35-.7-1.57-.91-1.69-1.4-3.03-1.78-4.81-2.91"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FC0",
    d: "M485.46 296.77l-23.91-15.62-.43.65 23.77 15.8z",
    strokeWidth: 0.1344096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.16 280.89c-.17-.91.09-2.13.74-2.26.04 0 .52-.17.82-.08.4 0 .48.13.65.43.35.82-.65 1.35-1.34 1.6-.18.05-.65.14-.74.35-.13.35-.04.22-.13.35.13-.04.17-.17.3-.26.52-.3 1.04-.39 1.78-.74.57-.26.65-1.39.26-1.73-.43-.35-1.78-.3-2.08.04-.65.74-.7 1.74-.56 2.73 0-.21.34-.17.3-.43z",
    fillRule: "evenodd",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.77 281.32c-.91-.04-2.08.35-2.13 1 0 .08-.08.6 0 .87.05.39.18.47.52.56.87.26 1.26-.78 1.4-1.52.04-.17.04-.65.25-.78.35-.17.26-.09.35-.17-.04.13-.17.21-.22.3-.21.56-.26 1.13-.52 1.9-.17.57-1.3.79-1.65.44-.43-.34-.56-1.69-.26-2.04.65-.73 1.65-.9 2.65-.9-.17.04-.13.38-.39.34z",
    fillRule: "evenodd",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.6 280.93c-.26.13-.26.48-.13.7.09.21.48.25.65.17.35-.22.56-.6.35-.96-.22-.3-.57-.04-.87.09z",
    fillRule: "evenodd",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.56 277.76s2.52 1 4.56 1.04c0 0 .08 1.78.52 2.3 0 0-1.83-.35-2.65.09 0 0-1.08-2.48-2.43-3.43z",
    fillRule: "evenodd",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.6 279.02s1 .43 1.82.43c0 0 .05.7.22.92 0 0-.74-.14-1.04.04 0 0-.44-1-1-1.39z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.77 282.88s.48-.82.6-1.13c.1-.17-.04 1 .4 1.13.56.74.69 2.26.69 2.65-.65.21-1.21.6-2.21.13-.35-.22-.09-.87.04-1.4.09-.25.18-.99.48-1.38z",
    fillRule: "evenodd",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.25 282.23c0 .13.09.65.04.56 0-.21.26.22.3.3.35.66.48 1.14.61 2.4M461.46 283.32c.22 1 .4.95.4 2.34l.08-.08M461.42 284.23c.17.7.13 1.04.17 1.39-.04 0-.26.17-.3.17",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fc0",
    d: "M497.78 276.81l-21.35-23.73-.43.52 21.13 23.82z",
    strokeWidth: 0.1344096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.61 253.08c.04-.95.56-2.08 1.21-2.04.05 0 .57-.04.83.09.39.08.43.26.52.6.17.87-.91 1.13-1.65 1.22-.17 0-.7-.04-.82.17-.22.3-.09.22-.22.3.13 0 .26-.12.35-.17.6-.17 1.13-.17 1.95-.3.56-.09.91-1.21.6-1.6-.3-.44-1.6-.74-1.99-.48-.82.56-1.08 1.52-1.17 2.56.04-.22.35-.13.39-.35z",
    fillRule: "evenodd",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.13 253.38c-.91-.26-2.13-.13-2.34.48 0 .04-.22.56-.18.82-.04.4.05.52.4.7.73.43 1.38-.48 1.69-1.18.08-.17.21-.6.43-.69.35-.09.26 0 .35-.09-.05.13-.18.18-.26.26-.35.52-.52 1-.96 1.74-.3.48-1.43.48-1.73.04-.3-.47-.09-1.78.26-2.04.78-.6 1.82-.56 2.77-.26-.17-.04-.21.3-.43.22z",
    fillRule: "evenodd",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.04 252.95c-.3.04-.35.43-.3.65.04.22.39.39.6.3.35-.13.7-.43.57-.82-.13-.35-.57-.17-.87-.13z",
    fillRule: "evenodd",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.92 248.69s2.17 1.56 4.12 2.08c0 0-.3 1.78 0 2.35 0 0-1.73-.74-2.6-.52 0 0-.44-2.65-1.52-3.91z",
    fillRule: "evenodd",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.57 250.43s.87.6 1.65.82c0 0-.13.7 0 .91 0 0-.7-.26-1.04-.17 0 0-.18-1.08-.61-1.56z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.74 254.9s.65-.7.87-.95c.13-.18-.3.95.08 1.21.4.82.13 2.3.05 2.73-.7.05-1.3.26-2.13-.43-.3-.26.09-.82.35-1.3.13-.26.39-.96.78-1.26z",
    fillRule: "evenodd",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.35 254.42l-.04.52c.04.26.26.35.3.65.13.74-.04 1.22-.09 2.17",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.26 255.29c.22.91.04 1.65-.09 2.52-.04 0 .09 0 .09-.05M476.13 256.81c-.13.35-.13.56-.17.95-.05-.04-.22.13-.26.1",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "matrix(-1 0 0 1 1030.05 0)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M531.13 247.35l-50.29 84.13h100.62z",
    fill: "#fc0",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.4342464
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M531.13 252.82l-45.38 75.93h90.8z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.1344096
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M499.2 306.18l-13.45 22.57h90.8l-13.49-22.57z",
    fill: "#007e93",
    stroke: "#007e93",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.25848
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.17,
    strokeMiterlimit: 2.61,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.24 266.09c2.12-1.91 4.73-2.69 7.76-2.73h.22c2.95.04 5.95.73 7.85 2.73",
    stroke: "#086aad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.19 266.18c2.08-1.95 4.77-2.69 7.8-2.73h.22c3.04 0 6.04.73 7.94 2.77",
    stroke: "#0863aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.15 266.31c2.08-2.04 4.81-2.78 7.9-2.82h.21c3.04.04 6.08.78 7.98 2.86",
    stroke: "#095fa8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.06 266.4c2.08-2.04 4.9-2.82 7.98-2.82h.26c3.08 0 6.12.78 8.03 2.95",
    stroke: "#0a58a5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.02 266.48c2.04-2.08 4.94-2.82 8.07-2.86h.21c3.17.04 6.2.82 8.12 3.03",
    stroke: "#0a52a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.94 266.57c2.04-2.13 4.99-2.86 8.15-2.86h.26c3.21.04 6.25.82 8.2 3.08",
    stroke: "#0b4d9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.89 266.7c2.04-2.17 5.03-2.95 8.24-2.95h.22c3.3.04 6.29.87 8.28 3.17",
    stroke: "#0c479d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.33 267.61c2.38-2.52 5.33-3.25 8.85-3.25h.21c3.87.04 7.16 1.34 9.07 4.03",
    stroke: "#270a7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.37 267.48c2.34-2.43 5.3-3.17 8.8-3.21h.22c3.78.04 7.03 1.3 8.98 3.95",
    stroke: "#241183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.46 267.39c2.3-2.43 5.2-3.17 8.67-3.17h.22c3.73.05 6.99 1.22 8.94 3.86",
    stroke: "#221786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.5 267.31c2.25-2.39 5.2-3.12 8.59-3.17h.21c3.7.05 6.9 1.17 8.9 3.78",
    stroke: "#1f1f8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.59 267.18c2.17-2.3 5.12-3.08 8.5-3.08h.17c3.65 0 6.86 1.04 8.86 3.64",
    stroke: "#1a258d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.63 267.09c2.12-2.3 5.12-3.04 8.41-3.08h.22c3.56.04 6.77 1 8.72 3.56",
    stroke: "#172d91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.67 267c2.08-2.26 5.07-3.04 8.33-3.04h.21c3.52 0 6.69.91 8.68 3.43",
    stroke: "#143393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.76 266.87c2.04-2.21 5.03-2.95 8.24-3h.17c3.47 0 6.64.87 8.64 3.39",
    stroke: "#113b97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.14 261.15c1.47-1.04 3.03-1.35 4.99-1.35 1.86 0 3.51.3 4.94 1.26",
    stroke: "#ff0a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.1 261.23c1.47-1.04 3.08-1.35 5.03-1.35 1.87 0 3.56.3 4.99 1.26",
    stroke: "#F10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.06 261.32a8.46 8.46 0 0 1 5.07-1.39c1.87 0 3.6.35 5.08 1.3",
    stroke: "#ff1500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.02 261.45c1.52-1.08 3.12-1.43 5.12-1.43 1.9 0 3.64.34 5.12 1.3",
    stroke: "#ff1a00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.97 261.54c1.52-1.08 3.16-1.43 5.16-1.43 1.9 0 3.69.35 5.16 1.3",
    stroke: "#ff2000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.93 261.62a8.53 8.53 0 0 1 5.2-1.48c1.91 0 3.74.4 5.21 1.4",
    stroke: "#ff2700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.88 261.71a8.58 8.58 0 0 1 5.25-1.48c1.9 0 3.77.4 5.25 1.4",
    stroke: "#ff2f00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.84 261.8c1.52-1.13 3.25-1.48 5.3-1.48 1.94 0 3.8.4 5.33 1.4",
    stroke: "#F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.8 261.88c1.52-1.13 3.3-1.52 5.33-1.52a9.8 9.8 0 0 1 5.38 1.43",
    stroke: "#ff3c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.75 261.97a8.8 8.8 0 0 1 5.38-1.52c1.95 0 3.9.44 5.42 1.43",
    stroke: "#ff4100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.7 262.06c1.57-1.13 3.35-1.52 5.43-1.52 2 0 3.95.44 5.47 1.43",
    stroke: "#ff4600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.54 264.01c1.69-1.3 4.38-1.95 6.63-1.95 2.4 0 5 .65 6.69 2",
    stroke: "#fff500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.63 263.88c1.65-1.3 4.3-1.91 6.55-1.91 2.34 0 4.9.6 6.6 2",
    stroke: "#ffeb00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.67 263.79c1.69-1.3 4.25-1.91 6.5-1.91 2.3 0 4.86.6 6.56 1.95",
    stroke: "#ffe000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.76 263.66c1.65-1.26 4.16-1.87 6.42-1.87 2.3 0 4.81.61 6.46 1.91",
    stroke: "#ffd600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.8 263.58c1.65-1.26 4.12-1.87 6.38-1.87 2.25 0 4.73.61 6.42 1.87",
    stroke: "#ffcf00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.89 263.45c1.65-1.26 4.08-1.82 6.29-1.82 2.25 0 4.69.56 6.33 1.86",
    stroke: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.93 263.36c1.65-1.26 4.03-1.82 6.24-1.82s4.6.56 6.25 1.82",
    stroke: "#ffba00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.02 263.23c1.6-1.21 3.95-1.78 6.16-1.78s4.55.57 6.2 1.78",
    stroke: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.06 263.14c1.65-1.26 3.9-1.78 6.11-1.78 2.17 0 4.52.56 6.12 1.78",
    stroke: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.15 263.01c1.6-1.21 3.82-1.74 6.03-1.74 2.12 0 4.42.53 6.03 1.74",
    stroke: "#ff9c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.19 262.93c1.6-1.21 3.82-1.74 5.98-1.74 2.13 0 4.39.53 6 1.7",
    stroke: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.28 262.79c1.6-1.17 3.73-1.7 5.9-1.7 2.08 0 4.34.53 5.9 1.66",
    stroke: "#ff8700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.32 262.71c1.6-1.21 3.68-1.7 5.85-1.7 2.09 0 4.26.53 5.86 1.66",
    stroke: "#ff7d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.4 262.58c1.57-1.17 3.6-1.65 5.78-1.65 2.04 0 4.2.52 5.77 1.6",
    stroke: "#ff7500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.45 262.49a9.47 9.47 0 0 1 5.72-1.65c2.04 0 4.13.48 5.69 1.56",
    stroke: "#ff6b00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.54 262.36c1.56-1.17 3.51-1.6 5.64-1.6 2 0 4.08.47 5.64 1.56",
    stroke: "#ff6100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.58 262.27a9.14 9.14 0 0 1 5.6-1.6c1.95 0 4.03.47 5.55 1.51",
    stroke: "#ff5700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.32 264.23c1.78-1.39 4.5-2.04 6.85-2.04 2.43 0 5.08.7 6.81 2.08",
    stroke: "#ebf605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.28 264.36c1.86-1.48 4.5-2.08 6.9-2.08 2.42 0 5.16.7 6.9 2.12",
    stroke: "#d6ec09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.19 264.49c1.95-1.56 4.5-2.17 6.98-2.17 2.48 0 5.2.74 6.94 2.17",
    stroke: "#c2e30e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.1 264.62c2.09-1.65 4.56-2.21 7.08-2.21 2.47 0 5.25.73 6.98 2.21",
    stroke: "#add912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.06 264.75a10.94 10.94 0 0 1 7.07-2.26c2.56 0 5.34.74 7.11 2.22",
    stroke: "#99cf16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.98 264.88a10.85 10.85 0 0 1 7.16-2.34c2.6 0 5.42.78 7.15 2.3",
    stroke: "#85c61a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.93 265.01c2.3-1.87 4.55-2.39 7.2-2.39 2.6 0 5.47.78 7.24 2.3",
    stroke: "#70bc1f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.84 265.14a10.57 10.57 0 0 1 7.29-2.47c2.64 0 5.5.82 7.29 2.38",
    stroke: "#5cb323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.76 265.22c2.51-2 4.6-2.47 7.37-2.47 2.65 0 5.56.82 7.38 2.38",
    stroke: "#47a928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.37 265.92c2.21-1.95 4.77-2.65 7.8-2.65 2.87 0 5.87.74 7.77 2.6",
    stroke: "#0d74a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.4 265.87c2.26-2 4.74-2.69 7.77-2.69 2.87 0 5.82.78 7.73 2.6",
    stroke: "#127a97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.46 265.79c2.3-2 4.73-2.65 7.72-2.65 2.82 0 5.82.78 7.68 2.56",
    stroke: "#17808b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.5 265.7c2.34-2 4.68-2.6 7.68-2.6 2.77 0 5.77.78 7.59 2.51",
    stroke: "#1a847d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.54 265.66c2.38-2.04 4.68-2.65 7.59-2.65 2.82 0 5.77.83 7.6 2.52",
    stroke: "#1e8a6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.59 265.57c2.43-2.04 4.64-2.6 7.55-2.6 2.77 0 5.72.82 7.55 2.51",
    stroke: "#238f5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.63 265.53c2.47-2.08 4.64-2.6 7.5-2.6 2.74 0 5.69.82 7.51 2.47",
    stroke: "#2b944e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.67 265.44c2.51-2.08 4.6-2.56 7.46-2.56 2.69 0 5.68.82 7.46 2.43",
    stroke: "#2f9b3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.04 260.97a8.55 8.55 0 0 0-4.9-1.26c-1.96 0-3.48.35-4.95 1.35",
    stroke: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.59 268.57c-2-2.82-5.38-4.17-9.37-4.17-3.6 0-6.51.78-8.99 3.3",
    stroke: "#2a007c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.99 265.92c-1.91-1.87-4.9-2.6-7.81-2.6-3.08 0-5.69.73-7.85 2.69",
    stroke: "#0671b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.73 267.09c-2.04-2.47-5.17-3.25-8.6-3.25-3.2 0-6.29.73-8.32 2.95",
    stroke: "#0c419a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.95 264.18c-1.74-1.39-4.38-2.04-6.77-2.04-2.3 0-5.08.65-6.77 1.95",
    stroke: "#FF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.64 262.06c-1.52-1-3.52-1.48-5.51-1.48-2.09 0-3.9.44-5.47 1.61",
    stroke: "#ff4d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.55 265.22c-1.78-1.56-4.73-2.43-7.42-2.43-2.82 0-4.86.48-7.42 2.56",
    stroke: "#33a02c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.17,
    strokeMiterlimit: 2.61,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.94 268.13a20.3 20.3 0 0 1 9.2-2.26c3.25 0 6.72 1.22 9.45 2.7l9.64 16.1c0 10.53-8.6 19.26-19.1 19.26A19.17 19.17 0 0 1 512 284.75l9.94-16.62z",
    stroke: "#fef2ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.14 266.09c3.2 0 6.63 1.26 9.32 2.69.05 0 9.5 15.84 9.5 15.88 0 10.37-8.45 19-18.82 19a18.9 18.9 0 0 1-18.88-18.91c0-.05 9.77-16.36 9.8-16.36a19.8 19.8 0 0 1 9.08-2.3z",
    stroke: "#fef2ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 266.61c3.16 0 6.5 1.17 9.1 2.6.1.05 9.25 15.32 9.25 15.45 0 10.1-8.24 18.53-18.35 18.53a18.4 18.4 0 0 1-18.31-18.44c0-.13 9.41-15.88 9.5-15.93a19.47 19.47 0 0 1 8.8-2.2z",
    stroke: "#fef0e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 267.13c3.08 0 6.33 1.13 8.85 2.52.17.08 9.02 14.84 9.02 15.05a18 18 0 0 1-17.87 17.97 17.9 17.9 0 0 1-17.84-17.92c0-.22 9.12-15.36 9.29-15.5a18.87 18.87 0 0 1 8.55-2.12z",
    stroke: "#feede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 267.87c2.95 0 6.07 1.08 8.5 2.43.26.17 8.6 14.06 8.6 14.4 0 9.38-7.69 17.19-17.1 17.19-9.37 0-17.01-7.6-17.05-17.14 0-.35 8.54-14.67 8.85-14.8a18.08 18.08 0 0 1 8.2-2.08z",
    stroke: "#fee8dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 268.39c2.86 0 5.9 1.04 8.24 2.34.35.22 8.33 13.54 8.33 13.97 0 9.12-7.46 16.7-16.57 16.7a16.6 16.6 0 0 1-16.53-16.65c0-.44 8.2-14.15 8.59-14.37a17.5 17.5 0 0 1 7.94-2z",
    stroke: "#fee6d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 269.13c2.73 0 5.64 1.04 7.85 2.26.48.26 7.94 12.75 7.94 13.32a15.9 15.9 0 0 1-15.8 15.92 15.83 15.83 0 0 1-15.79-15.84c0-.6 7.73-13.45 8.2-13.75a16.68 16.68 0 0 1 7.6-1.91z",
    stroke: "#fee3cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 269.65c2.69 0 5.42.95 7.63 2.17.52.3 7.68 12.23 7.68 12.89 0 8.41-6.9 15.4-15.31 15.4a15.3 15.3 0 0 1-15.27-15.32c0-.7 7.37-12.97 7.9-13.27a15.9 15.9 0 0 1 7.37-1.87z",
    stroke: "#fee0cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 270.17c2.6 0 5.25.91 7.37 2.08.57.35 7.42 11.76 7.42 12.5 0 8.11-6.64 14.88-14.8 14.88-8.1 0-14.7-6.6-14.74-14.84 0-.78 7.02-12.5 7.63-12.84a15.7 15.7 0 0 1 7.12-1.78z",
    stroke: "#fedec6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 273.47c2.04 0 4.08.7 5.72 1.6 1.05.61 5.73 8.42 5.73 9.72a11.5 11.5 0 0 1-11.45 11.5 11.5 11.5 0 0 1-11.46-11.5c0-1.3 4.82-9.32 5.9-9.93 1.7-.87 3.52-1.39 5.56-1.39z",
    stroke: "#fdcdaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 273.69c2 0 3.99.7 5.6 1.6 1.08.66 5.6 8.16 5.6 9.5 0 6.17-5.04 11.25-11.2 11.25a11.2 11.2 0 0 1-11.2-11.2c0-1.39 4.65-9.11 5.77-9.76a11.45 11.45 0 0 1 5.43-1.39z",
    stroke: "#fdcdaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 274.94c1.78 0 3.55.6 4.99 1.43 1.26.74 4.94 6.86 4.94 8.42 0 5.47-4.47 9.98-9.93 9.98s-9.9-4.43-9.94-9.94c0-1.6 3.82-7.9 5.12-8.63a9.96 9.96 0 0 1 4.82-1.26z",
    stroke: "#fdc59e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 275.2c1.73 0 3.47.56 4.86 1.39 1.3.78 4.81 6.6 4.81 8.2a9.66 9.66 0 1 1-19.35.04c0-1.65 3.65-7.63 5-8.41a9.88 9.88 0 0 1 4.68-1.22z",
    stroke: "#fdc59e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.14 266.35c3.16 0 6.55 1.21 9.2 2.65.04.04 9.37 15.57 9.37 15.66 0 10.24-8.38 18.79-18.57 18.79a18.68 18.68 0 0 1-18.62-18.7c0-.09 9.6-16.1 9.64-16.14a19.54 19.54 0 0 1 8.98-2.26z",
    stroke: "#fef0e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 266.87c3.12 0 6.42 1.17 8.98 2.56.13.09 9.15 15.1 9.15 15.27 0 9.94-8.15 18.23-18.13 18.23-9.94 0-18.01-8.07-18.1-18.18 0-.18 9.29-15.62 9.42-15.7a18.9 18.9 0 0 1 8.68-2.18z",
    stroke: "#feede3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 267.39c3.03 0 6.24 1.13 8.72 2.47.22.13 8.9 14.58 8.9 14.84 0 9.68-7.95 17.7-17.62 17.7a17.66 17.66 0 0 1-17.58-17.65c0-.26 8.9-15.15 9.12-15.28a18.61 18.61 0 0 1 8.46-2.08z",
    stroke: "#feebdf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 267.61c3 0 6.16 1.13 8.63 2.47.22.13 8.72 14.32 8.72 14.63 0 9.54-7.8 17.44-17.35 17.44a17.4 17.4 0 0 1-17.31-17.4c0-.3 8.72-14.88 8.98-15.06a18.5 18.5 0 0 1 8.33-2.08z",
    stroke: "#feebdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 268.13c2.9 0 5.99 1.08 8.37 2.39.3.17 8.46 13.8 8.46 14.18 0 9.25-7.55 16.93-16.83 16.93a16.82 16.82 0 0 1-16.8-16.88c0-.4 8.38-14.4 8.73-14.58a17.5 17.5 0 0 1 8.07-2.04z",
    stroke: "#fee8d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 268.65c2.82 0 5.81 1.04 8.11 2.3.4.22 8.2 13.28 8.2 13.75 0 8.99-7.33 16.45-16.31 16.45a16.42 16.42 0 0 1-16.32-16.36c0-.52 8.07-13.97 8.46-14.19a17.24 17.24 0 0 1 7.86-1.95z",
    stroke: "#fee6d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 268.91c2.77 0 5.72 1 7.98 2.26.43.26 8.07 13.01 8.07 13.53 0 8.85-7.2 16.19-16.05 16.19-8.81 0-15.97-7.16-16.06-16.1 0-.56 7.9-13.71 8.33-13.97 2.39-1.17 4.9-1.91 7.73-1.91z",
    stroke: "#fee3d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 269.39c2.73 0 5.5 1 7.72 2.21.52.3 7.85 12.5 7.85 13.1 0 8.6-7.03 15.67-15.57 15.67s-15.5-6.94-15.54-15.58c0-.65 7.55-13.23 8.07-13.49a16.14 16.14 0 0 1 7.47-1.91z",
    stroke: "#fee0cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 269.91c2.64 0 5.33.95 7.5 2.13.52.34 7.55 12.01 7.55 12.7 0 8.25-6.77 15.1-15.05 15.1a15.06 15.06 0 0 1-15.02-15.05c0-.74 7.2-12.76 7.77-13.06a15.75 15.75 0 0 1 7.25-1.82z",
    stroke: "#fedec8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 270.43c2.56 0 5.16.91 7.24 2.04.61.39 7.3 11.5 7.3 12.28 0 7.98-6.56 14.62-14.54 14.62-7.99 0-14.45-6.5-14.5-14.58 0-.82 6.86-12.23 7.51-12.62a15.14 15.14 0 0 1 6.99-1.74z",
    stroke: "#fddbc5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 270.65c2.51 0 5.07.91 7.11 2.04.65.39 7.16 11.24 7.16 12.06 0 7.85-6.42 14.36-14.27 14.36a14.32 14.32 0 0 1-14.28-14.32c0-.86 6.73-12.01 7.42-12.4a15.12 15.12 0 0 1 6.86-1.74z",
    stroke: "#fddbc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 270.91c2.47 0 4.99.87 6.98 2 .7.43 7.03 10.97 7.03 11.84 0 7.72-6.29 14.1-14.01 14.1a14.05 14.05 0 0 1-14.02-14.05c0-.91 6.55-11.76 7.25-12.2 2.08-1.04 4.3-1.69 6.77-1.69z",
    stroke: "#fdd9bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 271.17c2.43 0 4.9.87 6.85 1.95.74.44 6.9 10.72 6.9 11.63 0 7.6-6.16 13.84-13.75 13.84a13.8 13.8 0 0 1-13.76-13.8c0-.95 6.38-11.5 7.12-11.93 2.04-1.04 4.2-1.69 6.64-1.69z",
    stroke: "#fdd9bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 271.43c2.38 0 4.81.82 6.72 1.9.78.49 6.77 10.47 6.77 11.42 0 7.42-6.07 13.58-13.5 13.58a13.55 13.55 0 0 1-13.49-13.54c0-1 6.2-11.28 6.99-11.71a13.8 13.8 0 0 1 6.5-1.65z",
    stroke: "#fdd6bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 271.69c2.34 0 4.73.82 6.6 1.87.82.47 6.63 10.2 6.63 11.19 0 7.29-5.94 13.32-13.23 13.32-7.3 0-13.2-5.9-13.24-13.28 0-1.04 6-11.02 6.86-11.5 1.95-1 4.03-1.6 6.38-1.6z",
    stroke: "#fdd6b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 271.95c2.3 0 4.64.78 6.5 1.82.83.52 6.51 9.94 6.51 10.98 0 7.16-5.85 13.1-13.01 13.1a13.03 13.03 0 0 1-12.98-13.06c0-1.08 5.82-10.8 6.69-11.28 1.95-1 3.99-1.56 6.29-1.56z",
    stroke: "#fdd4b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 272.17c2.25 0 4.55.82 6.37 1.82.87.52 6.38 9.68 6.38 10.76 0 7.03-5.72 12.84-12.75 12.84a12.72 12.72 0 0 1-12.71-12.8c0-1.12 5.64-10.54 6.55-11.06 1.9-.95 3.9-1.56 6.16-1.56z",
    stroke: "#fdd4b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 272.43c2.21 0 4.47.78 6.24 1.78.92.52 6.25 9.41 6.25 10.54a12.6 12.6 0 0 1-12.5 12.58c-6.85 0-12.45-5.6-12.49-12.53 0-1.13 5.51-10.29 6.47-10.85a13.36 13.36 0 0 1 6.03-1.52z",
    stroke: "#fdd2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 272.69c2.17 0 4.38.74 6.11 1.74.96.56 6.12 9.15 6.12 10.37 0 6.72-5.5 12.27-12.23 12.27s-12.2-5.46-12.24-12.27c0-1.18 5.34-10.07 6.34-10.6a12.3 12.3 0 0 1 5.9-1.51z",
    stroke: "#fdd1b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 272.95c2.12 0 4.25.74 5.99 1.7 1 .56 5.98 8.89 5.98 10.15 0 6.59-5.38 12.01-11.97 12.01a12 12 0 0 1-11.98-12.01c0-1.22 5.17-9.81 6.2-10.37a12.24 12.24 0 0 1 5.78-1.48z",
    stroke: "#fdd0b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 273.21c2.08 0 4.16.7 5.86 1.65 1.04.6 5.85 8.68 5.85 9.93 0 6.42-5.25 11.76-11.71 11.76-6.47 0-11.67-5.2-11.72-11.76 0-1.25 5-9.54 6.03-10.15a12 12 0 0 1 5.69-1.43z",
    stroke: "#fdd0ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 273.95c1.95 0 3.9.65 5.5 1.56 1.1.65 5.43 7.9 5.43 9.29 0 6.03-4.9 11.02-10.93 11.02-6.03 0-10.94-4.9-10.94-10.98 0-1.43 4.47-8.9 5.64-9.54a11.4 11.4 0 0 1 5.3-1.35z",
    stroke: "#fdcaa6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 274.21c1.9 0 3.82.65 5.38 1.52 1.13.7 5.3 7.64 5.3 9.07 0 5.9-4.78 10.76-10.68 10.76-5.9 0-10.68-4.78-10.72-10.72 0-1.48 4.34-8.63 5.51-9.33 1.6-.82 3.3-1.3 5.2-1.3z",
    stroke: "#fdcaa4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 274.47c1.86 0 3.73.6 5.25 1.48 1.17.69 5.2 7.37 5.2 8.85a10.5 10.5 0 0 1-10.45 10.5 10.49 10.49 0 0 1-10.46-10.46c0-1.52 4.17-8.37 5.38-9.07 1.56-.82 3.21-1.3 5.08-1.3z",
    stroke: "#fdc8a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 274.73c1.82 0 3.64.6 5.12 1.43 1.21.74 5.07 7.12 5.07 8.64 0 5.64-4.6 10.24-10.2 10.24-5.59 0-10.15-4.56-10.19-10.2 0-1.56 4-8.16 5.25-8.85a10.6 10.6 0 0 1 4.95-1.26z",
    stroke: "#fdc8a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 275.46c1.69 0 3.38.56 4.73 1.35 1.34.78 4.68 6.33 4.68 7.98a9.4 9.4 0 1 1-18.83.04c0-1.69 3.47-7.42 4.82-8.2a9.63 9.63 0 0 1 4.6-1.17z",
    stroke: "#fdc39b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 275.72c1.65 0 3.3.52 4.6 1.3 1.39.83 4.55 6.08 4.55 7.81 0 5.04-4.12 9.2-9.15 9.2a9.17 9.17 0 0 1-9.16-9.2c0-1.73 3.3-7.16 4.69-7.98a9.6 9.6 0 0 1 4.47-1.13z",
    stroke: "#fdc398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 275.98c1.6 0 3.2.52 4.51 1.26 1.39.82 4.38 5.81 4.38 7.59 0 4.9-3.99 8.94-8.9 8.94s-8.89-4-8.89-8.94c0-1.78 3.08-6.94 4.56-7.77a9.07 9.07 0 0 1 4.34-1.08z",
    stroke: "#fdc097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 276.25c1.56 0 3.12.48 4.38 1.21 1.43.87 4.25 5.6 4.25 7.38a8.67 8.67 0 0 1-8.63 8.68 8.7 8.7 0 0 1-8.68-8.68c0-1.82 2.95-6.68 4.47-7.5a8.56 8.56 0 0 1 4.2-1.09z",
    stroke: "#fdc095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 276.46c1.52 0 3 .52 4.25 1.21 1.47.87 4.12 5.34 4.12 7.16a8.39 8.39 0 1 1-16.79 0c0-1.86 2.78-6.42 4.3-7.29a8.84 8.84 0 0 1 4.12-1.08z",
    stroke: "#fdbe92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 276.72c1.47 0 2.9.48 4.12 1.17 1.47.91 3.99 5.08 3.99 6.94a8.17 8.17 0 0 1-8.11 8.16 8.15 8.15 0 0 1-8.16-8.16c0-1.9 2.6-6.2 4.16-7.07a8.28 8.28 0 0 1 4-1.04z",
    stroke: "#fdbe90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 276.98a7.9 7.9 0 0 1 3.99 1.13c1.52.9 3.9 4.81 3.9 6.72a7.9 7.9 0 1 1-15.8 0c.01-1.95 2.44-5.94 4.05-6.85 1.17-.6 2.43-1 3.86-1z",
    stroke: "#fdbb8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 277.24c1.39 0 2.73.43 3.86 1.08 1.56.96 3.77 4.56 3.77 6.51a7.65 7.65 0 0 1-15.27 0c0-2 2.26-5.68 3.9-6.64a7.57 7.57 0 0 1 3.74-.95z",
    stroke: "#fdbb8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 277.5a7.3 7.3 0 0 1 3.73 1.04c1.6.96 3.64 4.3 3.64 6.3 0 4.07-3.3 7.41-7.37 7.41s-7.38-3.34-7.38-7.42c0-2.04 2.08-5.46 3.78-6.42a7.5 7.5 0 0 1 3.6-.91z",
    stroke: "#fdb98a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 277.76c1.3 0 2.56.39 3.6 1 1.65 1 3.51 4.03 3.51 6.07a7.16 7.16 0 0 1-7.11 7.16 7.13 7.13 0 0 1-7.12-7.16c0-2.08 1.91-5.2 3.6-6.16a6.84 6.84 0 0 1 3.52-.91z",
    stroke: "#fdb98a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 277.98c1.26 0 2.47.4 3.51 1 1.65 1 3.34 3.77 3.34 5.85a6.88 6.88 0 1 1-13.75 0c0-2.12 1.78-4.98 3.51-5.94a6.8 6.8 0 0 1 3.39-.91z",
    stroke: "#fcb687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 278.24c1.21 0 2.38.35 3.38.95a7.37 7.37 0 0 1 3.21 5.64c0 3.7-2.95 6.64-6.6 6.64s-6.63-2.95-6.63-6.64c0-2.16 1.6-4.72 3.38-5.72a6.3 6.3 0 0 1 3.26-.87z",
    stroke: "#fcb685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 278.5c1.17 0 2.3.35 3.25.91a6.66 6.66 0 0 1 3.08 5.42 6.35 6.35 0 1 1-12.71.05 6.72 6.72 0 0 1 3.25-5.56 6.21 6.21 0 0 1 3.13-.82z",
    stroke: "#fcb485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.09 290.95a6.1 6.1 0 1 0-.04-12.18 6.1 6.1 0 0 0 .04 12.18z",
    stroke: "#fcb482"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M531.14 291a6.1 6.1 0 1 0-.06-12.2 6.1 6.1 0 0 0 .06 12.2z",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.13,
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.13
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.44 278.89l.69-3.25M531.79 278.81l.34-3.3M531.14 278.76v-3.3M530.53 278.81l-.35-3.3M529.88 278.89l-.7-3.25M529.27 279.07l-1.04-3.17M528.66 279.28l-1.34-3.03M528.1 279.54l-1.7-2.86M527.53 279.89l-1.95-2.65M527.06 280.32l-2.26-2.47M526.58 280.76l-2.47-2.22M526.19 281.28l-2.7-1.95M525.8 281.8l-2.86-1.65M525.54 282.36l-3.04-1.34M525.28 282.97l-3.13-1.04M525.1 283.58l-3.21-.7M525.02 284.23l-3.3-.35M524.97 284.88h-3.3M525.02 285.49l-3.3.34M525.1 286.14l-3.25.69M525.28 286.74l-3.17 1.05M525.5 287.35l-3.04 1.35M525.8 287.92l-3.52 2.17M526.14 288.48l-7.2 5.12M526.54 288.96l-7.68 6.81M526.97 289.43l-6.34 7.08M527.49 289.83l-4.82 6.46M528 290.22l-5.02 8.72M528.58 290.48l-2.78 6.33M529.18 290.74l-2.82 8.72M529.79 290.91l-1.21 5.86M530.44 291l-.87 9.02M531.7 291l.35 3.29M532.35 290.91l1.95 8.5M532.96 290.74l1.65 5.03M533.56 290.52l3.87 8.37M534.17 290.22l4.12 7.11M534.69 289.87l5.95 7.81M535.2 289.48l5.22 6.03M535.65 289.05l7.72 7.02M536.04 288.52l4.2 3.04M536.43 288l2.86 1.65M536.69 287.44l3.04 1.34M536.95 286.83l3.12 1.04M537.12 286.22l3.2.7M537.2 285.57l3.3.35M537.25 284.92h3.3M537.2 284.31l3.3-.34M537.12 283.66l3.26-.69M536.95 283.06l3.17-1.04M536.73 282.45l3.04-1.35M536.47 281.84l2.87-1.65M536.12 281.32l2.65-1.95M535.69 280.8l2.47-2.21M535.26 280.37l2.2-2.48M534.74 279.93l1.95-2.64M534.22 279.59l1.64-2.87M533.65 279.33l1.35-3.04M533.04 279.07l1.05-3.13M531.14 270.99v-2.56M528.27 271.3l-.52-2.52M525.5 272.17l-1.05-2.3M522.98 273.64l-1.52-2.08M520.8 275.55l-1.9-1.69M519.12 277.94l-2.26-1.3M517.9 280.58l-2.43-.82M517.29 283.4l-2.56-.26M517.29 286.31l-2.56.26M517.9 289.18l-2.47.78M543.15 291.87l2.22 1.3M544.32 289.22l2.43.78M544.93 286.4l2.56.26M544.93 283.49l2.56-.26M544.32 280.63l2.48-.78M543.15 277.98l2.22-1.3M541.46 275.64l1.9-1.74M539.34 273.69l1.47-2.09M536.82 272.21l1.04-2.34M534.04 271.3l.52-2.47"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M534.69 287.74s-.87-.48-1.4-.48c-.51 0-2.81-.13-3.72.13-.52.18-.96.61-.96.61s.61.6 1.82.74c1.26.08 2.04 0 2.7-.22.73-.22 1.56-.78 1.56-.78z",
    fillRule: "evenodd",
    strokeMiterlimit: 2.61,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.79 286.83s.08-1.7 1.26-3.82c0 0-.4.6-.61 1.13 0 0-.65.35-1.04-.13-.4-.39-.18-.56.13-1.17.26-.48.21-.96.56-1.26.3-.3.56-.35 1.39-.35.82 0 1.34.09 2.04 1.04.6.83.95 1.6 1.26 2.04.69 1.09.69 2.39.69 2.39l.22 1.04s-.87-.48-1.4-.48c-.51 0-2.81-.13-3.72.13-.52.18-.96.6-.96.6s-.34-.77.18-1.16z",
    fillRule: "evenodd",
    strokeMiterlimit: 2.61,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.79 286.83s.65-.4 2.86-.35c2.56.05 2.65.22 2.82.4",
    strokeMiterlimit: 2.61,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 296.38v-8.98s.3-.26 1 0v8.9s.21 6.8-.53 6.76c-.86 0-.47-1.56-.47-6.68z",
    fillRule: "evenodd",
    strokeMiterlimit: 2.61,
    fill: "#FC0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#e60000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.72 288.83l.17.35-1.73.73.26.61-.26.09c-.18-.4-.3-.52-.74-.43l-.13-.27 2.43-1.08zM519.85 288.09a.77.77 0 0 1-.3-.48c-.1-.43.08-.9.64-1.04.26-.08.92-.08 1.13.74.09.35.05.78-.52 1l-.08-.35c.3-.09.39-.35.3-.65-.09-.35-.4-.48-.74-.39-.35.09-.48.39-.43.7.04.17.17.34.39.43l.04.26-1.47.13-.3-1.35.34-.04.26 1.08.74-.04zM519.16 283.23c-.44 0-.61.3-.61.6-.04.27 0 .66.39.7.26 0 .35-.17.4-.3l.25-.78c.09-.35.35-.57.74-.52.65.04.78.65.73 1.13-.04.47-.21.69-.3.78-.26.21-.48.26-.74.21l.05-.34c.47.04.65-.35.7-.7.03-.26 0-.7-.4-.74-.3-.04-.39.1-.52.53l-.17.56c-.09.17-.22.56-.7.52-.43-.04-.82-.35-.78-1 .09-.95.65-1 .96-1v.35zM519.03 281.54l.78.26.47-1.43.3.13-.47 1.39.87.3.52-1.56.3.08-.6 1.91-2.6-.82.6-1.91.35.13z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.81 277.53a.9.9 0 0 0-.53.4l-.6 1.04 2.29 1.43.21-.28-1-.62.44-.72c.3-.52.1-.94-.25-1.16a.71.71 0 0 0-.56-.09zm.16.4c.06.02.12.06.18.1.26.17.27.4.1.66l-.35.56-.75-.44.41-.62c.1-.17.23-.28.4-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.97 277.68l-.21.26-1.74-1.65-.65.65-.22-.22 1.52-1.6.26.21-.65.7zM524.88 276.9l-1.6-2.17.26-.22 1.65 2.17zM524.84 274.03l.39.74 1.35-.7.13.3-1.3.7.38.78 1.48-.73.13.26-1.78.95-1.26-2.43 1.78-.9.13.3zM529.88 274.77l-.35-1.56c0-.09-.04-.4-.13-.65l-.26 2.38-.35.1-1.26-2.1c.05.27.13.62.18.66l.34 1.6-.34.05-.61-2.65.52-.09 1.26 2.09.26-2.43.52-.13.56 2.69-.34.04z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.78 272l-.13 2.72 1.16.03c.6.04.97-.28.97-.72.04-.48-.3-.6-.47-.69a.6.6 0 0 0 .38-.56c.04-.39-.2-.7-.72-.75l-1.2-.03zm.4.38l.6.06c.4 0 .53.11.53.37-.04.3-.21.39-.56.35h-.63l.07-.79zm-.06 1.12l.66.06c.26 0 .56.1.56.44 0 .26-.21.44-.56.44l-.69-.06.03-.88zM533.81 272.25l-.72 2.66.35.09.28-1.13.87.25c.44.13.4.38.35.6-.05.08-.17.48-.13.65l.44.13v-.03c-.09-.09-.07-.14-.03-.31l.06-.47c.13-.35 0-.48-.12-.56.17-.1.44-.15.53-.54.17-.56-.22-.8-.66-.93l-1.22-.41zm.35.47l.78.28c.17.04.44.11.31.5-.09.35-.33.32-.6.28l-.74-.22.25-.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.03 273.82l-.43.69 1.3.78-.17.26-1.3-.74-.44.78 1.39.83-.13.26-1.74-1 1.35-2.34 1.73 1-.17.3z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.31 275.81l-2.06 1.72.68.87c.61.65 1.34.36 1.82-.03.6-.48.76-1.18.28-1.75l-.72-.81zm-.03.6l.4.5c.3.34.26.72-.21 1.15-.48.4-.92.38-1.22.03l-.4-.47 1.43-1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.2 278.85l-.79.39.7 1.3-.3.17-.66-1.34-.82.39.74 1.47-.3.14-.92-1.78 2.43-1.22.91 1.78-.3.13zM541.24 283.71l-.05-.35 1.87-.26-.09-.6.26-.05c.13.44.18.57.61.61l.04.26-2.64.39z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.09 284.53c-.13 0-.36-.01-.63.25-.17.22-.21.48-.21.66-.05.6.39.9.78.9.21.05.51-.03.69-.37.04.13.18.34.53.34.34.04.72-.17.72-.78.04-.6-.39-.84-.7-.84-.25 0-.44.11-.52.37-.1-.3-.31-.49-.66-.53zm0 .44c.22 0 .45.18.4.53 0 .26-.12.47-.46.47-.4 0-.44-.32-.44-.53 0-.4.28-.47.5-.47zm1.19.12c.17 0 .38.1.34.44 0 .35-.21.44-.34.44a.51.51 0 0 1-.4-.5c0-.22.18-.38.4-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.89 286.92c.86.22.78.87.73 1.13-.13.43-.52.74-1 .6-.43-.08-.56-.43-.69-.9l-.08-.3c-.1-.4-.26-.53-.4-.57l-.34 1.43-.3-.09.43-1.78c.56.18.78.48.9.87l.1.4c.08.3.17.56.52.6.17.09.47 0 .56-.4.13-.47-.3-.6-.48-.64l.05-.35zM540.25 289.52l.17-.35 1.7.83.25-.57.26.09c-.17.43-.21.6.13.87l-.08.26-2.43-1.13z",
    fillRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M531.13 252.82l-45.38 75.93h90.8z",
    stroke: "#000",
    strokeMiterlimit: 2.61,
    strokeWidth: 0.29983679999999996,
    fill: "none"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2.61,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.56 319.37c1.17.3 2.6.48 4.03.09 1.95-.48 3.78-1.6 6.08-1.4 1.64.18 3.9 1.61 6.63 1.61 2.7 0 3.6-.95 5.95-1.43 1.65-.35 2.47-.17 4.25.22 2.04.39 3.08 1.56 6.5 1.3",
    stroke: "#000",
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.55 322.63c1.51-1.17 4.2-1.65 6.24-1.17 2.7.56 3.87 1.26 6.73 1.21 2.13-.04 3.95-1.47 6.12-1.47 3.6 0 3.73.74 6.9 1.34.82.18 1.86.18 2.69 0 1.17-.21 2.2-.6 3.16-1.08 1-.52 3.52-.44 4.78-.3 2.25.21 3.16 1.08 3.64 1.2 1.21.31 2.6.49 4.03.1 1.96-.57 3.78-1.83 6.12-1.57 1.65.18 3.9 1.78 6.6 1.78 2.69 0 3.64-1.08 5.94-1.6 1.7-.4 2.52-.18 4.3.21 2 .48 3.08 1.78 6.5 1.48",
    stroke: "#fff",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.43 320.07c1.52-1 4.2-1.43 6.24-1.04 2.7.52 3.87 1.17 6.73 1.13 2.13-.05 3.95-1.35 6.12-1.35 3.6 0 3.73.7 6.9 1.22a9.3 9.3 0 0 0 2.69 0c1.17-.18 2.2-.57 3.16-1 .96-.44 3.52-.35 4.78-.26 2.25.22 3.16.95 3.64 1.08 1.21.26 2.6.44 4.03.09 1.96-.52 3.78-1.6 6.12-1.39 1.65.17 3.9 1.6 6.6 1.56 2.69 0 3.64-.95 5.94-1.43 1.7-.35 2.52-.13 4.3.22 2 .43 3.08 1.6 6.5 1.3",
    stroke: "#fff",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.74 327.49c1.52-1.26 4.2-1.78 6.29-1.3 2.65.65 3.82 1.43 6.68 1.39 2.13-.05 4-1.65 6.12-1.65 3.64 0 3.73.82 6.9 1.52.82.17 1.86.17 2.73 0 1.17-.26 2.17-.7 3.12-1.26 1-.52 3.52-.43 4.82-.3 2.21.25 3.12 1.17 3.6 1.34 1.22.3 2.6.52 4.08.09 1.95-.65 3.77-2 6.07-1.74 1.65.22 3.9 2 6.64 2 2.65 0 3.6-1.22 5.9-1.83 1.7-.43 2.52-.17 4.3.27 2.04.52 3.08 2 6.5 1.64",
    stroke: "#fff",
    strokeWidth: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.96 323.23c1.56-1.04 4.25-1.43 6.29-1.04 2.69.52 3.86 1.13 6.72 1.08.96 0 1.83-.26 2.74-.56",
    stroke: "#fff",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.7 318.81c.44-.13 1.7-.74 3.52-.74 3.65 0 1.35.05 4.51.61.83.13 3.13.17 3.78-.48M547.28 328.49a14.2 14.2 0 0 0 3.16-1c.96-.43 3.47-.39 4.78-.26 2.25.22 3.12.96 3.64 1.04 1.22.3 2.6.48 4.04.09 1.95-.48 3.77-1.6 6.11-1.39 1.65.17 3.9 1.6 6.6 1.6",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.87 318.46c2.69 0 3.6-.95 5.94-1.43 1.65-.35 2.48-.13 4.25.22 2.04.39 3.08 1.6 6.51 1.3",
    stroke: "#fff",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.87 327.75a9.63 9.63 0 0 1 6.29-1.04c2.69.52 3.86 1.17 6.72 1.13 2.13-.05 3.95-1.35 6.12-1.35 3.6 0 3.73.7 6.9 1.22a9.3 9.3 0 0 0 2.69 0c1.17-.18 2.17-.57 3.17-1 .95-.44 3.47-.35 4.77-.22 2.25.18 3.12.91 3.64 1.04",
    stroke: "#000",
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.6 324.45c1.56-1.04 4.25-1.43 6.29-1.04 2.69.52 3.86 1.13 6.68 1.08 2.17-.04 3.99-1.34 6.12-1.3 3.64 0 3.77.65 6.94 1.22a9.3 9.3 0 0 0 2.69 0c1.17-.22 2.17-.57 3.17-1 .95-.44 3.47-.4 4.77-.26 2.21.22 3.12.95 3.64 1.04 1.17.3 2.6.48 4.04.09 1.95-.48 3.77-1.6 6.12-1.4 1.77.18 4.03 1.61 6.6 1.61 2.68 0 3.64-.95 5.93-1.43 1.65-.35 2.48-.17 4.3.22 2 .39 3.08 1.56 6.46 1.26",
    stroke: "#000",
    strokeWidth: 0.61
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.26,
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.82 311.82c.43.09 1.47-.74 1.78-.96.43-.26.65-.9 1-1.25.34-.4 1.38-.87 1.86-1.18 2.08-1.3 3.04-2.03 4.47-3.94a22.17 22.17 0 0 1 7.11-6.51c.91-.52 2.3-.35 3.3.08.3.14.7.48 1.04.74 1.22.96 2.87 1.65 4.86 2.26 1.91.56 2.34 1.82 3.86 3.17.74.65 1.57 1.21 2.48 1.64.08.05.3.4.39.44.86.65 1.82 1.17 2.56 1.82a83.7 83.7 0 0 1 3.99 3.86c.21.22.3.65.52.83 1 .95 1.95 1.95 3.16 2.51 1.22.61 2.3 1.4 3.43 2.09-11.54.43-22.17-.3-33.75.04-.3.04-.4 0-2.13 0-.87-.04-1.39.04-2.26.04-3.51-.04-6.85-.04-10.97-.08l3.3-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.16 317.12c-.96-.6-1.91-1.26-2.95-1.78-1.22-.56-2.17-1.56-3.17-2.52-.22-.17-.3-.6-.52-.82-1.3-1.35-2.6-2.6-4-3.86-.73-.65-1.69-1.17-2.55-1.82-.09-.05-.3-.4-.4-.44-.9-.43-1.73-1-2.47-1.65-1-.9-1.51-1.73-2.34-2.38l.04-.05c.48-.34 1-.7 1.57-.95.73-.44 1.9-.3 2.73.08.26.1.6.35.87.57 1 .82 2.38 1.39 4.03 1.9 1.6.49 2 1.53 3.26 2.61.6.57 1.26 1.04 2.04 1.4.04.03.21.3.3.38.74.52 1.52.96 2.17 1.52a77.03 77.03 0 0 1 3.3 3.21c.17.17.21.52.43.7.83.78 1.65 1.6 2.65 2.08 1 .47 1.86 1.13 2.82 1.69-2.6.13-5.16.13-7.72.13h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.87 303.06c.34.09.73.22 1.12.35 1.61.48 2 1.52 3.26 2.6.6.57 1.26 1.04 2.04 1.39.04.04.21.3.3.39.74.52 1.52.96 2.17 1.52a77.03 77.03 0 0 1 3.3 3.2c.17.18.22.53.43.7.83.78 1.65 1.61 2.65 2.09.87.39 1.6.95 2.39 1.43 2.12 0 4.25-.04 6.46-.13-.87-.52-1.65-1.13-2.6-1.56-.91-.44-1.6-1.18-2.39-1.91-.17-.13-.22-.44-.39-.61-1-1.04-2-1.95-3.04-2.9-.56-.53-1.26-.92-1.9-1.4-.1-.04-.27-.3-.3-.34a7.8 7.8 0 0 1-1.88-1.26c-1.12-1-1.47-1.96-2.95-2.39-1.47-.43-2.73-1-3.64-1.7-.26-.2-.56-.47-.78-.56-.78-.34-1.82-.47-2.52-.08-.6.35-1.21.74-1.73 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.46 305.53c.3.35.6.7 1.04 1.08a7.8 7.8 0 0 0 1.86 1.26c.05.05.22.3.3.35.66.48 1.35.87 1.92 1.39 1.04.95 2.04 1.87 3.03 2.9.18.18.22.48.4.61.78.74 1.47 1.48 2.38 1.91.6.3 1.13.65 1.7 1h-.05c2.52 0 5.03 0 7.6-.09-.7-.43-1.3-.9-2.09-1.25-.74-.4-1.3-1-1.95-1.57-.13-.13-.18-.34-.3-.52-.83-.82-1.61-1.56-2.44-2.34-.47-.43-1.04-.74-1.56-1.13-.09-.04-.22-.22-.26-.26a7.09 7.09 0 0 1-1.52-1c-.9-.82-1.17-1.6-2.34-1.95a9.11 9.11 0 0 1-3-1.39c-.21-.17-.43-.35-.6-.43-.65-.26-1.48-.4-2.04-.09-.78.43-1.43.91-2.09 1.48v.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.12 315.6a9.2 9.2 0 0 0-1.57-.91c-.73-.4-1.3-1-1.95-1.56-.13-.13-.17-.35-.3-.52-.83-.83-1.6-1.57-2.43-2.35-.48-.43-1.04-.74-1.56-1.13-.1-.04-.22-.21-.26-.26a7.09 7.09 0 0 1-1.52-1c-.78-.69-1.09-1.34-1.87-1.77l.04.04c.4-.3.83-.6 1.26-.82.52-.3 1.22-.18 1.78.04.13.04.35.26.52.39.65.48 1.48.87 2.56 1.17 1 .3 1.22.96 2 1.65.39.35.82.65 1.3.87.04.04.13.21.22.26.43.3.95.56 1.34.95.7.65 1.4 1.3 2.09 2 .13.13.13.35.26.43.52.48 1.04 1 1.65 1.3.65.35 1.21.74 1.82 1.09-1.82.09-3.6.09-5.38.09v.04z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#00633b",
    strokeWidth: 0.13,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.96 298.72c.56-.09.3-.22.82.13M509.92 299.41c.6-.09.82-.48 1.26.04M509.35 299.81c.26 0 .43-.3 1.26.17M508.75 300.5c.52-.13.82-.09 1.34.09M508.05 301.02c.6-.17.86.26 1.52.13M507.3 301.76c.4 0 .53-.13.87 0 .44.13.35.04.79.09M506.49 302.54c.43 0 .56-.09.95-.04.52.08.4.13.91.04M506 303.19a3.12 3.12 0 0 1 1.74.17M504.84 304.79c.73-.22 1.08-.22 1.73.04M492.78 317.2c2.38-.4 5.2.04 7.59-.3M505.19 304.01c.6-.22.47-.13 1.08-.09.61.09.87.18 1.04.09M504.23 305.4c.6-.3 1.34-.13 1.95.04M505.8 306.05c-.65-.17-1.35-.04-2.04 0M505.28 306.75c-.7-.22-1.44-.3-2.13-.09M502.19 307.27c.86 0 1.69-.22 2.56.09M501.46 307.96c.9-.3 1.82-.04 2.77.04M500.59 308.48c.95-.04 1.86-.04 2.82-.09.13 0 .43-.13.6.09M503.7 309c-1.43.3-2.86.09-4.29.13M502.93 309.74c-.48.04-1.22.22-1.87.17-.13-.04-.26-.13-.39-.13a5.22 5.22 0 0 0-2.17.22M498.2 310.52c.3-.17.65-.22.95-.13.91.13 1.78 0 2.65.22.22.08.43.21.7.21M497.68 310.87c.65 0 1.3-.09 1.95.04.82.22 1.6.4 2.47.44h-.08M497.07 311.35c.7 0 1.34.13 2.04.26.9.17 1.82-.09 2.69.17M496.25 311.78c.9.39 1.86.04 2.82.22.9.17 1.73.13 2.6.3M495.64 312.47c1.39.04 2.77 0 4.2.26.4.09 1 .26 1.52.17M495.17 313.08c1.34.26 2.73.04 4.07.4.61.12 1.26.25 1.91.25h-.08M494.6 314.12c.13-.04.3-.13.43-.13 1.08 0 2.13.17 3.25.04.87-.04 1.83-.13 2.7.18h-.1M494.12 314.82c2.17-.22 4.38.09 6.55 0M493.73 315.47c2.3.26 4.6.04 6.85.22M493.39 316.16c1 .22 2-.09 3 .13.73.13 1.38.26 2.12.13.65-.17 1.26.04 1.86-.04M509.66 306.88h.21M509.44 307.14c.08.04.21-.13.26.04M509.18 307.49h.47M508.96 307.79h.6M508.57 308.18c.34.04.65.09 1 .09h-.1M508.23 308.7c.39-.13.82 0 1.21-.13h-.09M507.7 309.31h1.66-.09M507.44 309.7c.6 0 1.17-.09 1.73.04h-.04M507.1 310.26c.65-.09 1.34 0 2.04.09M506.7 310.87c.44-.04.79.22 1.22.3.35.1.65 0 .96-.04M506.58 311.35c.65.22 1.34.26 2 .3M506.19 311.87a4.4 4.4 0 0 1 1.65.26c.26.09.52.04.73.04h-.04M505.45 312.69c.7-.3 1.52-.09 2.25.13.26.09.52-.04.83-.04h-.09M505.36 313.21c.82-.26 1.69-.26 2.47.09.13.04.3 0 .43 0M504.84 313.82c1.08.22 2.21-.13 3.3.17M504.54 314.3c.86.35 1.82 0 2.77.26.3.09.61.09.91-.04M503.93 314.95c.39-.13.78-.22 1.17-.13 1.04.26 2 .17 2.95.3M503.45 315.64c.21-.04.43.13.6.09 1.35-.22 2.7 0 4-.09M503.1 316.16c1.05.39 2.13 0 3.26.3.44.13 1 .18 1.48 0M502.72 316.9c1.6.04 3.12-.04 4.99.17M511.83 307.7c.17-.04.3.13.47.09M511.6 308.18c.22-.04.4-.13.61-.09M511.44 308.61c.3.04.56-.04.86.09M511.22 309.22c.34 0 .73 0 1.08.09M510.92 309.83c.47-.13.9.04 1.39-.09M510.87 310.26c.43.17.86.04 1.34.09v-.09M510.6 310.95c.44-.04.83-.09 1.22.09.13.04.3 0 .48-.09M510.57 311.56c.56-.22 1.12.13 1.73 0M510.3 312.3c.66-.04 1.27.09 1.92 0M510.09 312.86c.26-.09.56-.26.82-.13.4.17.87.09 1.3.13M509.96 313.52c.73-.26 1.52.17 2.25-.22M509.87 314.21c.34-.09.7-.09 1.08.04.4.09.87.05 1.35-.04M509.66 314.86c.86-.17 1.78 0 2.69-.04l-.05.04M509.14 315.47c1.12-.09 2.3-.22 3.42-.22M509.27 316.16c1.26-.22 2.56-.13 3.86-.17M509.05 316.86c1.26.17 1.52-.09 2.77-.13.22 0 1.3-.22 1.52-.26.18-.04.57 0 .74 0M509.05 317.2c1.9-.17 3.86.17 5.81-.3M500.76 316.99h1.51M508.14 317.2c.17.09.39-.09.52.09M515.39 317.07c1.56-.17 3.16.3 4.73 0M514.6 316.55c1-.3 1.9-.09 2.86.09.09 0 .09.21.17.26.87.13 1.7 0 2.56-.05M509.05 316.47h-1M502.85 316.25c-.7.04-1.4.04-2.09.13M515.9 301.63h.31M516.04 302.06c.13.04.26 0 .39-.04M516.12 302.76c.04-.04.04-.13.08-.13.13-.04.3-.04.44-.04M516.3 303.19c.21-.13.47-.04.73-.04M517.12 303.58c-.26-.04-.48.04-.7.13M516.73 304.32a.96.96 0 0 1 .7-.13M517.73 304.71h-1M517.03 305.23c.34 0 .7.09.95-.13M518.25 305.84c-.4 0-.74 0-1.09.09M517.42 306.57c.39.04.78-.04 1.17-.22M518.68 306.75c-.35.17-.74.22-1.13.3M517.77 307.7c.47-.26 1.04-.04 1.52-.22M519.42 308.09c-.4 0-.78-.09-1.17.04-.13.05-.22.13-.4.13M518.16 309.22c.3-.13.6-.35.95-.3.04-.22.26 0 .35-.13.08-.05.26 0 .43 0M520.1 309.44c-.56-.04-1.16.09-1.73.17M518.55 310.35c.65-.26 1.3-.26 2-.35M518.6 311.17c.74-.17 1.52-.13 2.21-.43M521.33 311.26c-.83.13-1.65 0-2.43.4M519.07 312.39c.13.04.21.13.34.09.79-.3 1.57-.57 2.35-.48M521.98 312.56c-.78.43-1.7.26-2.56.3-.09 0-.18.1-.3.13M519.42 313.52c.95-.13 1.86-.17 2.82-.3M522.85 313.82c-.78.13-1.52-.04-2.26.13-.35.04-.65.17-1 .26M519.72 314.82c.13 0 .3.04.39-.04.95-.57 2.04-.4 3.08-.44M523.5 314.95c-.87 0-1.78-.22-2.65.09-.3.13-.6.3-.95.3M520.2 315.99c.47-.09.9-.3 1.34-.4 1-.12 2-.03 3-.03M524.54 316.08a3.2 3.2 0 0 0-1.7 0c-.86.22-1.64.43-2.51.48M520.8 316.99c.7-.09 1.35-.3 2.05-.48.56-.13 1.12-.04 1.69-.04M520.85 317.38c1.04-.17 2.08 0 3.12-.35.35-.13.74.09 1.13.05M525.1 316.68c1.73.13 3.47-.22 5.16.17M525.45 317.2c.21.04.39-.13.52-.13 1.43 0 2.86.04 4.3.13M529.75 313.52h.21M529.83 313.99c.17.09.34-.22.52 0M529.96 314.51h.9M530.22 315.25c.3-.35.73 0 1.04-.22M530.44 315.95c.39-.35.95.04 1.34-.3M530.53 316.47c.56-.17 1.17.04 1.73-.3M530.74 316.99c.86-.39 1.86.17 2.69-.43M530.83 317.42c1.08-.35 2.21 0 3.3-.04M534.82 317.38c1.9-.09 3.86-.13 5.77 0M534 316.68c1.69.17 4.25 0 6.38.17M524.63 303.62c.13 0 1.3-.22 1.39-.22M525.02 303.93c.34.04 1.17.04 1.47-.22M525.58 304.49c0-.04 1-.22 1.04-.22.13-.04.3 0 .47-.04M526.02 304.79c.17-.13 1.56-.04 1.82-.09M528.18 305.1c-.26 0-1.4.04-1.57.17M527.58 305.88c.17-.13 1-.26 1.3-.26M529.53 306.1c-.35 0-1.09.09-1.48.09M528.79 306.75a3.6 3.6 0 0 0 1.3-.3M530.79 307.09c-.4 0-.91.04-1.44.09M530 307.7c.48 0 1.18 0 1.53-.13M532.05 307.87c-.3.17-.91.22-1.3.3M531.39 308.79c.39-.26 1.08-.09 1.56-.26M533.48 309.09c-.48 0-.96-.04-1.3.04-.13.05-.18.13-.4.13M535.04 310.26c-.7-.04-1.26.09-1.87.17M533.78 311.09c.6-.26 1.34-.22 2.04-.35M535.3 312.91c.13.04.78-.09.9-.13 1.05-.13 1.22-.35 2.18-.26M538.95 312.95a27 27 0 0 1-2.7.35c-.12 0-.43.08-.51.13M536.3 313.82c.95-.17 2.34-.13 3.3-.26M540.64 314.08c-.78.13-1.7 0-2.43.17-.35.05-1 .1-1.35.18M537.77 315.03c.13 0 .3 0 .39-.04.78-.52 2.04-.44 3.16-.44M542.03 315.08c-1.09 0-1.52.04-2.35.13-.3.04-.73.22-1.12.22M539.47 315.99c1-.17 2.9-.4 1.78-.3 1.04-.1 1.21-.1 2.34-.1M543.89 316.03a5.47 5.47 0 0 0-1.91.04c-.44.13-.3.26-1.78.3M540.8 316.68c.7-.09.79-.04 1.44-.22.52-.13 1.21-.08 1.87-.08M541.16 316.94c1.08-.13 1.21-.09 2.34-.04.3 0 .56 0 .96-.05M524.28 303.19c.26-.13.43-.22.9-.17-.12-.18.22 0 .31-.09 0-.09.26-.04.44-.04M523.76 302.67c.26-.13.52-.13.95-.09-.13-.21.26 0 .3-.13.05-.04.3 0 .48 0M532.39 309.96c.3-.13.26-.22.7-.13-.14-.22.47 0 .51-.13.05-.09.52-.04.7-.04M534.22 311.69c.7-.17 1.56-.17 2.17-.48M537.43 312c-.83.13-2.04.04-2.7.39M524.84 301.93c-.78-.04-.91.22-1.48.22M533.39 304.1c.13 0 1-.17 1.12-.17M533.74 304.45c.52-.13.9 0 1.21-.22M534.17 304.88c0-.04.82-.13.86-.13.13-.04.3-.04.44-.04M534.6 305.27c.18-.13 1.31-.09 1.57-.13M536.47 305.53c-.26-.04-1.3.13-1.48.22M535.56 306.23c.17-.13 1.3-.26 1.56-.22M537.73 306.44c-.35 0-1.3.09-1.65.13M536.64 307.01c.34 0 1.43-.09 1.6-.26M538.86 307.35c-.35 0-.96.04-1.44.09M537.86 307.92c.43 0 1.39 0 1.69-.17M540.03 308.05c-.26.17-1.09.26-1.44.35M539.38 308.87c.34-.22 1.04-.09 1.47-.22M541.33 309.18c-.4 0-.87-.04-1.17.04-.13.05-.18.13-.35.09M542.76 310.26c-.61-.04-1.13.09-1.7.17M541.63 311.04c.56-.26 1.26-.26 1.9-.35M543.15 312.73c.17.04.6-.13.7-.13.99-.13 1.12-.35 2.03-.3M546.36 312.73a14.2 14.2 0 0 1-2.43.3c-.13 0-.44.1-.52.13M543.93 313.52c.87-.13 2.17-.13 3.03-.22M547.93 313.78c-.7.09-1.52 0-2.22.13-.3.09-.95.09-1.25.17M545.32 314.64c.13 0 .26 0 .34-.04.7-.48 1.87-.4 2.96-.4M549.23 314.69c-1 0-1.44.04-2.17.13-.48.04-1.04.22-1.17.22M546.62 315.51c.9-.17 2.9-.35 1.86-.26.96-.09 1.13-.09 2.17-.09M550.92 315.6a4.64 4.64 0 0 0-1.74 0c-.35.09-.48.26-1.9.3M547.8 316.21c.65-.09 1.04-.09 1.6-.22.48-.13 1.13-.08 1.74-.08M548.45 316.55c.9-.13 1.04-.22 2.12-.17.3 0 .52-.05.87-.09M532.87 303.75c.26-.13.17-.22.56-.17.3-.09.52.04.56-.09 0-.04.26-.04.4-.04M532.26 303.41c.26-.13.3-.26.7-.22.38-.04.56 0 .6-.13.04-.04.26 0 .43 0M540.46 309.96c.26-.13.13-.17.52-.13-.09-.17.43 0 .48-.09.04-.08.47-.04.65-.04M542.03 311.56c.65-.17 1.43-.17 2-.4M544.98 311.87c-.74.13-1.7-.04-2.26.26M533.43 302.58c-.74-.04-1.35.3-1.78.6M542.33 306.4c.08 0 1.13-.17 1.17-.17M542.68 306.66c.39-.09.95-.04 1.17-.22M543.07 306.96l.86-.13c.1-.04.22 0 .35 0M543.4 307.27c.14-.09 1.22-.09 1.4-.13M545.06 307.44a3.35 3.35 0 0 0-1.18.17M544.5 307.96c.13-.09.82-.17 1.04-.17M545.97 308.14c-.22 0-1 .09-1.26.09M545.19 308.57c.26 0 1.04-.09 1.21-.22M546.88 308.83c-.3 0-.78.04-1.13.04M546.1 309.26c.34 0 1.04 0 1.3-.13M547.8 309.39c-.22.13-.87.17-1.13.22M547.06 310c.26-.17 1.04-.04 1.34-.13M548.79 310.22c-.35 0-.7-.04-.96.04-.08.05-.17.05-.3.05M549.88 311.09c-.48-.04-1.09.13-1.48.17M548.88 311.61c.39-.17 1.08-.13 1.56-.22M549.96 312.91c.08.04.65-.04.74-.04.73-.09.86-.26 1.56-.22M552.66 312.99c-.87.13-1.22.17-1.91.22l-.48.04M550.62 313.56c.7-.13 1.82-.09 2.51-.17M553.83 313.78c-.52.09-1.17 0-1.7.09-.43.08-1.04.13-1.08.13M551.6 314.47c.1 0 .7-.17.75-.17.86-.1 1.17-.18 2-.22M554.82 314.47c-.78 0-1.09.04-1.65.09-.4.04-1.04.26-1.13.26M552.7 315.16c.56-.13 2.25-.3 1.56-.26l1.65-.09M556.13 315.16c-.48-.04-.96-.09-1.35 0-.22.09-.47.17-1.56.26M553.65 315.64c.52-.09.86-.04 1.3-.17.39-.13.91-.05 1.34-.1M554.09 315.9c.7-.09.95-.17 1.78-.13.21 0 .39 0 .69-.04M542.1 306.1c.22-.09.31-.22.61-.17.22-.05.4.04.4-.05.04-.04.21-.04.34-.04M541.76 305.79c.21-.09.26-.17.56-.17.3 0 .43 0 .48-.05 0-.08.22-.04.3-.04M547.93 310.82c.21-.09.26-.13.6-.09-.13-.13.3 0 .35-.08 0-.05.35 0 .48 0M549.3 312.08c.48-.13 1.1-.13 1.53-.35M551.57 312.3c-.57.09-1.4-.04-1.87.22M542.68 305.18c-.57-.04-.7.17-1.04.43M550.44 306.75l1.08-.13M550.75 307.05c.34-.09.9-.09 1.08-.22M551.09 307.31l.82-.13c.09-.04.22 0 .3 0M551.48 307.74a5.5 5.5 0 0 1 1.21-.26M552.96 307.74a3.56 3.56 0 0 0-1.22.22M552.22 308.27c.08-.09.95-.22 1.17-.17M553.83 308.4c-.26 0-.96.04-1.3.13M552.96 308.79c.26 0 1.08-.09 1.21-.22M554.65 309c-.26 0-.91.09-1.26.13M553.9 309.44c.31 0 1 0 1.22-.13M555.48 309.52c-.22.13-.96.13-1.22.22M554.82 310.13c.21-.17.9-.09 1.21-.17M556.39 310.31c-.3 0-.61 0-.87.04-.04.05-.26.05-.35.05M557.39 311.09c-.44-.04-.96.13-1.35.17M556.39 311.65c.39-.17 1.08-.17 1.56-.26M557.47 312.82c.08 0 .6-.09.7-.09.69-.08.81-.21 1.42-.17M559.94 312.86c-.78.13-1.13.17-1.74.22-.09 0-.39 0-.43.04M558.04 313.47a47.1 47.1 0 0 1 2.34-.22M561.07 313.6c-.52.04-1.13 0-1.6.09-.4.08-.96.08-1 .13M558.99 314.21c.08 0 .65-.13.7-.13.77-.09 1.08-.17 1.86-.22M561.98 314.21c-.74.04-1 .04-1.52.09-.4.04-.96.26-1.09.26M559.99 314.86c.56-.09 2.12-.3 1.47-.22.65-.08.78-.08 1.52-.08M563.2 314.86c-.48-.04-.96-.09-1.26 0-.22.09-.44.17-1.43.22M560.9 315.29c.43-.04.78-.04 1.21-.17.35-.09.78-.05 1.22-.05M561.25 315.55c.7-.09.9-.13 1.69-.13.22 0 .35 0 .6-.04M550.27 306.49c.17-.09.21-.17.52-.13.22-.04.35 0 .39-.04 0-.05.17-.05.3-.05M549.92 306.23c.21-.09.21-.17.52-.13.26-.04.39 0 .43-.09 0-.04.17-.04.3-.04M555.6 310.87c.18-.09.27-.09.53-.09-.09-.13.3 0 .34-.04.05-.04.35-.04.44-.04M556.82 312c.43-.09 1.08-.09 1.47-.26M558.99 312.21c-.57.09-1.44-.04-1.87.17M550.79 305.66c-.52-.04-.7.17-1 .39"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.53 373.25l.75 5.56c-1.47-.48-2.82.38-3.47 1.6-1.04 2.08-.12 3.65 1.88 4.65l2.69 1.38 5-9.72-2-1-2 3.9h-.04l-.43-5.15-2.38-1.22zm.75 7.34c.32.03.67.17 1.03.35l.25.12-1.4 2.66-.25-.13c-.91-.47-1.52-1.04-1-2.12.35-.68.83-.92 1.37-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M482.28 372.87l2.9 1.95 1.65-2.43-3.03-2.04 1.04-1.56 4.86 3.3-6.08 9.03-4.86-3.26 1.04-1.52 3.04 2 1.35-2-2.95-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.84 365.62l-2.65 3.07-.85-.69c-1.73-1.52-3.48-1.45-5 .28-1.6 1.91-1.01 3.58.82 5.1l2.28 1.96 7.06-8.28-1.66-1.44zm-5.53 3.54c.38.03.8.29 1.25.68l.35.25-1.97 2.29-.32-.26c-.82-.69-1.29-1.34-.46-2.34.41-.48.77-.66 1.15-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M467.44 368.27l-1.48-1.65 4.51-4.12c1-.87 2.35-2.26 1.09-3.64-1.26-1.4-2.78-.22-3.78.69l-4.5 4.08-1.48-1.6 4.81-4.39c2-1.78 4.25-2.26 6.3-.04 2.03 2.25 1.34 4.5-.66 6.29l-4.81 4.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.44 347.66c-.62-.05-1.27.1-1.94.56-.95.69-1.69 1.93-1.12 3.19-.79-.35-1.67-.11-2.32.37-1.78 1.22-1.74 2.73-.53 4.47l1.56 2.25 9-6.16-1.97-2.84c-.73-1.06-1.65-1.76-2.68-1.84zm-.03 2.34c.65-.06 1.13.47 1.59 1.12l.28.35-2.31 1.56-.19-.25c-.56-.82-1.15-1.79-.06-2.53.26-.17.47-.23.69-.25zm-3.19 3.16c.4-.01.74.26 1.06.75l.16.21-2.13 1.47-.15-.21c-.48-.7-.62-1.35.25-1.91.31-.23.57-.31.81-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M458.59 340.33l1.6-.87 2.56 4.68-9.59 5.21-1.08-1.95 7.98-4.29zM458.41 335.39l.87 2.03-9.98 4.39-.87-2.04zM447.22 327.83c-.52.78-.61 1.82-.35 2.73.7 2 2.82 2.56 4.64 2 1.74-.56 3.08-2.34 2.43-4.3a3.46 3.46 0 0 0-1.86-2.03l2.38-.79c.65.7 1.18 1.4 1.44 2.26 1 3.04-.78 6.08-3.65 7.03-2.95.95-6.25-.35-7.29-3.51a5.88 5.88 0 0 1-.17-2.6l2.43-.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.44 313.25l-10.25 6.22.31 1.69 11.78 2.37-.44-2.28-2.4-.53-.72-3.88 2.16-1.28-.44-2.31zm-3.32 4.53l.47 2.63-4.12-.5v-.07l3.65-2.06zM446.69 292.88c-2.82.01-5.04 1.97-5.28 5.06l-.25 3.12 10.84.88.25-3.13a5.31 5.31 0 0 0-5-5.9c-.19-.02-.37-.04-.56-.03zm-.41 2.5c.24-.02.49-.03.75 0 1.95.13 3.22 1.21 3 3.68v.32l-6.53-.54.03-.31c.15-2.01 1.09-3.04 2.75-3.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M449.6 284.31l-.69 3.43 2.9.61.75-3.56 1.77.35-1.17 5.77-10.67-2.26 1.17-5.72 1.82.39-.73 3.55 2.34.48.74-3.42zM454.16 270.82l-1.3 3.3 2.73 1.04 1.35-3.38 1.73.65-2.12 5.46-10.2-3.94 2.17-5.47 1.74.65-1.35 3.43 2.21.86 1.3-3.3zM460.71 264.18l1.65.83-2.43 4.77-9.72-4.99 1-1.95 8.07 4.12zM462.32 249.87c-.7.04-1.3.26-1.74.82-.43.61-.43 1.44.13 1.87 1.48 1.08 3.56-3 6.5-.78 1.74 1.3 2.13 3.34.75 5.2-.91 1.26-2.3 1.65-3.78 1.52l-.22-1.95c.87.26 1.91.09 2.48-.7.56-.69.3-1.6-.4-2.08-.9-.69-1.77 0-2.6.52-1.3.83-2.51 1.26-3.86.26a3.23 3.23 0 0 1-.7-4.6 4.81 4.81 0 0 1 2.83-1.77l.6 1.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.19 240.31l-1.22 1.22 4.97 10.97 1.62-1.69-1-2.25 2.72-2.81 2.28.94 1.63-1.69-11-4.69zm1.72 3.1l3.47 1.59-1.69 1.78-1.81-3.34.03-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M482.84 238.93l1.17 1.43-4.16 3.39-6.86-8.5 1.74-1.4 5.68 7.03zM485.49 226.3l2.04-1.25 2.25 11.8-1.08.7-9.68-7.12 2-1.3 6.25 4.77.04-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.25 221l-1.56.75.56 12.03 2.13-.97-.1-2.53 3.56-1.59 1.75 1.75 2.16-.97-8.5-8.47zm.44 3.56l2.69 2.78-2.26 1-.43-3.72v-.06zM507.41 217.22c-.56 0-1.16.1-1.75.28l-3 .88 3.06 10.43 2.97-.84a5.32 5.32 0 0 0 3.78-6.78c-.71-2.44-2.65-3.99-5.06-3.97zm-.07 2.28c1.36.05 2.27.84 2.72 2.41.57 1.86-.02 3.4-2.4 4.09l-.32.12-1.81-6.28.31-.12a5.04 5.04 0 0 1 1.5-.22zM520.5 214.06l-.62.06a5.55 5.55 0 0 0-4.76 6.41 5.55 5.55 0 0 0 6.29 4.94 5.58 5.58 0 0 0 4.81-6.41 5.61 5.61 0 0 0-5.72-5zm-.25 2.44c1.73-.22 3.19 1.21 3.41 2.81.17 1.48-.87 3.52-2.57 3.78-1.69.22-3.25-1.52-3.47-3-.17-1.6.85-3.37 2.63-3.59zM529.53 213.56l-.12 10.91h2.21l.04-4.38h.03l2.69 4.44 2.68.03-3.15-4.62c1.52-.22 2.34-1.61 2.34-3 .04-2.35-1.51-3.3-3.72-3.35l-3-.03zm2.25 1.94h.31c1.04 0 1.86.25 1.82 1.47 0 1.21-.78 1.53-1.91 1.53h-.25l.03-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M555.08 222.92l-3.43-.87-.7 2.87 3.56.9-.47 1.79-5.69-1.43 2.66-10.6 5.68 1.44-.44 1.82-3.56-.9-.55 2.33 3.38.83zM565.2 227.87l2.72-6.81 2.04.82-4.11 10.33-1.48-.61-2.73-9.29h-.05l-2.73 6.86-2.04-.78 4.17-10.42 1.46.57 2.7 9.33zM578.16 236.98l-1 1.56-4.51-2.82 5.82-9.24 1.86 1.17-4.82 7.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.72 233.25l-10.5 5.91 1.81 1.46 2.16-1.21 3.03 2.53-.75 2.34 1.84 1.47 3.75-11.41-1.34-1.09zm-1.63 3.16l-1.25 3.62-1.9-1.53 3.15-2.09zM605.06 250.31l-11.62 2.97 1.34 1.88 2.44-.57 2.28 3.16-1.34 2.09 1.4 1.91 6.53-10.06-1.03-1.38zm-2.34 2.63l-2.16 3.18-1.44-2 3.6-1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M605.8 273.82l-1-2 5.65-3.86-7.34.78-.34-.65 5.03-5.34v-.04l-6.51 2.17-1-2 10.85-3.34.74 1.39-5.16 5.73 7.59-.83.73 1.43zM612.88 279.93l-1.14-3.34-2.77.96 1.17 3.47-1.78.6-1.86-5.6 10.33-3.46 1.9 5.55-1.78.6-1.17-3.46-2.25.78 1.13 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.81 282.16l-10.62 2.25.43 2.15 4.29-.9h.06l-3.75 3.65.59 2.6 3.81-4.07c.57 1.44 2.07 1.9 3.41 1.6 2.3-.48 2.92-2.16 2.44-4.38l-.66-2.9zm-1.34 2.62l.06.28c.22 1.04.15 1.91-1.06 2.13-1.17.26-1.63-.45-1.85-1.53l-.06-.25 2.91-.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M611.22 296.3l-.25-2.18 10.84-1.26.26 2.17zM619.69 306.83a3.26 3.26 0 0 0 1.12-2.52c-.04-2.12-1.95-3.3-3.81-3.25-1.83 0-3.65 1.3-3.6 3.38 0 .91.47 1.87 1.17 2.48l-2.52.04c-.39-.82-.7-1.65-.7-2.56a5.58 5.58 0 0 1 5.56-5.64c3.12-.04 5.86 2.17 5.94 5.51 0 .87-.21 1.78-.6 2.52l-2.56.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.66 308.88l-.25 2.31 2.15 1.19-.47 3.9-2.43.56-.25 2.35 11.62-2.85.22-1.75-10.59-5.71zm3.65 4.46l3.41 1.57v.03l-3.72.84.31-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M612.05 340.16a3.46 3.46 0 0 0 2-1.91c.77-2-.53-3.82-2.26-4.51-1.7-.65-3.86-.17-4.65 1.73-.34.92-.26 1.96.18 2.78l-2.39-.9c-.04-.92 0-1.79.35-2.66a5.59 5.59 0 0 1 7.29-3.08c2.9 1.13 4.6 4.26 3.38 7.34a5.77 5.77 0 0 1-1.52 2.12l-2.38-.91zM604.85 347.1l1.65-3.08-2.6-1.44-1.74 3.26-1.6-.91 2.77-5.16 9.59 5.2-2.78 5.16-1.64-.91 1.77-3.2-2.13-1.13-1.68 3.08zM597.51 355.7l5.95 4.28-1.3 1.82-8.99-6.58.92-1.26 9.67-.36h.04l-5.99-4.38 1.3-1.78 9.03 6.6-.9 1.3-9.68.3zM596.82 364.88l1.6-1.64 1.3 1.26-4.68 4.9-1.3-1.26 1.56-1.65-6.55-6.29 1.52-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.53 363.41l-1.72 1.37 2.81 3.41v.03l-4.93-1.6-2.07 1.69 5.41 1.47c-1 1.17-.75 2.73.16 3.81 1.47 1.78 3.31 1.53 5 .1l2.28-1.91-6.94-8.37zm2.09 6.12l1.91 2.31-.22.16c-.82.69-1.56 1.01-2.34.09-.78-.95-.37-1.68.5-2.37l.15-.19zM578.72 369.06l-2 1.25.44 2.44-3.35 2.06-1.93-1.47-2 1.25 9.59 7.22 1.44-.9-2.19-11.85zm-1.25 5.72l.97 3.63h-.06l-3-2.32 2.09-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M563.9 379.38l-.8-1.65 4.82-2.3 4.69 9.9-2 .9-3.85-8.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.f33a701da1f6d083c4809c11135b6649.svg";
export { ForwardRef as ReactComponent };